/**
 * Created by Yuvashree.M on 04-01-2018.
 */
export class FontTranslationProp {
  public static get hy(): translateFontProp {
    return {
      fc21PortraitgameOverTextFontsize: 21,
      fcbfooterBetFontSize: 18,
      fcbhintTextFontSize: 19,
      fcbhintQuestionMarkNumberFontSize: 19,
      fcbspreadhintTextFontSize: 18,
      fcbfooterPaidFontSize: 16,
      fcbfooterCreditFontSize: 18,
      fcbTrendTextFontSize: 26,
      fcbTrendTextNameFontSize: 26,
      fcbTrendTextValueFontSize: 69,
      fcbTrendFooterValueFontSize: 14,
      fcbTrendHeaderFontSize: 20,
      fcbTrendShuffleTextFontSize: 21,
      fcbTrendTotalValueTextFontSize: 28,
      fcbTrendFooterValueKeyFontSize: 20,
      fcbTrendTextFontFamily: 'DejaVuSans',
      footerBetFontFamily: 'DejaVuSans',
      keyBoardTextFamily: 'DejaVu-Sans',
      alertTextFontFamily: 'DejaVuSans',
      footerPaidFontFamily: 'DejaVuSans',
      footerCreditFontFamily: 'DejaVuSans',
      fc21footerBetFontSize: 15,
      fc21footerPaidFontSize: 16,
      fc21footerCreditFontSize: 14,
      fcbaccaratbetLimitMinFontSize: 18,
      fcbaccaratbetLimitMaxFontSize: 18,
      fcbaccaratbetLimitMinFontFamily: 'DejaVuSans-Bold',
      fcbaccaratbetLimitMaxFontFamily: 'DejaVuSans-Bold',
      fc21betLimitMinFontSize: 15,
      fc21betLimitMinFontSizePortrait: 15,
      fc21betLimitMaxFontSize: 15,
      fc21betLimitMaxFontSizePortrait: 15,
      fc21betLimitMinFontFamily: 'DejaVuSans-Bold',
      fc21betLimitMaxFontFamily: 'DejaVuSans-Bold',
      fc21paysTextFontFamily: 'DejaVuSans',
      fc21UserNameDesktopFontSize: '.5',
      fc21UserNamemobileFontSize: '.5',
      fcbTrendTotalValueTextFontFamily: 'DejaVuSans',
      fc21placeBetsFontSize: 10,
      fc21placeBetsFontFamily: 'DejaVuSans',
      paysContentFontSize: 13,
      percentageContentFontSize: 16,
      paysContentTop: 5,
      percentageContentTop: 20,
      menuFontFamily: 'Verdana-Bold',
      TN_pays_blank_position_16_Top: 462,
      TN_pays_blank_position_17_Top: 462,
      TN_pays_blank_position_16_Left: 89,
      TN_pays_blank_position_17_Left: 89,

      splitCard_13_top: 294,
      landscapeSplitCard_13_top: 294,
      landscapeTnimage_split_height: 593,
      tnimage_split_height: 593,
    };
  }

  public static get 'zh-Hans'(): translateFontProp {
    return {
      fc21PortraitgameOverTextFontsize: 24,
      fcbfooterBetFontSize: 33,
      fcbhintTextFontSize: 22,
      fcbhintQuestionMarkNumberFontSize: 22,
      fcbspreadhintTextFontSize: 22,
      fcbfooterPaidFontSize: 33,
      fcbfooterCreditFontSize: 33,
      fcbTrendTextFontSize: 26,
      fcbTrendTextNameFontSize: 26,
      fcbTrendTextValueFontSize: 69,
      fcbTrendFooterValueFontSize: 21,
      fcbTrendHeaderFontSize: 30,
      fcbTrendShuffleTextFontSize: 24,
      fcbTrendTotalValueTextFontSize: 30,
      fcbTrendFooterValueKeyFontSize: 20,
      fcbTrendTextFontFamily: 'HiraginoSansGBW3',
      footerBetFontFamily: 'HiraginoSansGBW3',
      keyBoardTextFamily: 'HiraginoSansGBW3',
      alertTextFontFamily: 'HiraginoSansGBW3',
      footerPaidFontFamily: 'HiraginoSansGBW3',
      footerCreditFontFamily: 'HiraginoSansGBW3',
      fc21footerBetFontSize: 21,
      fc21footerPaidFontSize: 21,
      fc21footerCreditFontSize: 21,
      fcbaccaratbetLimitMinFontSize: 18,
      fcbaccaratbetLimitMaxFontSize: 18,
      fcbaccaratbetLimitMinFontFamily: 'HiraginoSansGBW3',
      fcbaccaratbetLimitMaxFontFamily: 'HiraginoSansGBW3',
      fc21betLimitMinFontSize: 16,
      fc21betLimitMinFontSizePortrait: 16,
      fc21betLimitMaxFontSize: 16,
      fc21betLimitMaxFontSizePortrait: 16,
      fc21betLimitMinFontFamily: 'HiraginoSansGBW3',
      fc21betLimitMaxFontFamily: 'HiraginoSansGBW3',
      fc21paysTextFontFamily: 'HiraginoSansGBW3',
      fc21UserNameDesktopFontSize: '.4',
      fc21UserNamemobileFontSize: '.4',
      fcbTrendTotalValueTextFontFamily: 'HiraginoSansGBW3',
      fc21placeBetsFontSize: 20,
      fc21placeBetsFontFamily: 'HiraginoSansGBW3',
      paysContentFontSize: 15,
      percentageContentFontSize: 14,
      paysContentTop: 4,
      percentageContentTop: 22,
      menuFontFamily: 'Verdana-Bold',
      TN_pays_blank_position_16_Top: 452,
      TN_pays_blank_position_17_Top: 452,
      TN_pays_blank_position_16_Left: 90,
      TN_pays_blank_position_17_Left: 90,

      splitCard_13_top: 294,
      landscapeSplitCard_13_top: 294,
      landscapeTnimage_split_height: 572,
      tnimage_split_height: 572,
    };
  }

  public static get 'zh-Hant'(): translateFontProp {
    return {
      fc21PortraitgameOverTextFontsize: 24,
      fcbfooterBetFontSize: 33,
      fcbhintTextFontSize: 22,
      fcbhintQuestionMarkNumberFontSize: 22,
      fcbspreadhintTextFontSize: 22,
      fcbfooterPaidFontSize: 33,
      fcbfooterCreditFontSize: 33,
      fcbTrendTextFontSize: 26,
      fcbTrendTextNameFontSize: 26,
      fcbTrendTextValueFontSize: 69,
      fcbTrendFooterValueFontSize: 21,
      fcbTrendHeaderFontSize: 30,
      fcbTrendShuffleTextFontSize: 24,
      fcbTrendTotalValueTextFontSize: 30,
      fcbTrendFooterValueKeyFontSize: 20,
      fcbTrendTextFontFamily: 'HiraginoSansGBW3',
      footerBetFontFamily: 'HiraginoSansGBW3',
      keyBoardTextFamily: 'HiraginoSansGBW3',
      alertTextFontFamily: 'HiraginoSansGBW3',
      footerPaidFontFamily: 'HiraginoSansGBW3',
      footerCreditFontFamily: 'HiraginoSansGBW3',
      fc21footerBetFontSize: 21,
      fc21footerPaidFontSize: 21,
      fc21footerCreditFontSize: 21,
      fcbaccaratbetLimitMinFontSize: 18,
      fcbaccaratbetLimitMaxFontSize: 18,
      fcbaccaratbetLimitMinFontFamily: 'HiraginoSansGBW3',
      fcbaccaratbetLimitMaxFontFamily: 'HiraginoSansGBW3',
      fc21betLimitMinFontSize: 16,
      fc21betLimitMinFontSizePortrait: 16,
      fc21betLimitMaxFontSize: 16,
      fc21betLimitMaxFontSizePortrait: 16,
      fc21betLimitMinFontFamily: 'HiraginoSansGBW3',
      fc21betLimitMaxFontFamily: 'HiraginoSansGBW3',
      fc21paysTextFontFamily: 'HiraginoSansGBW3',
      fc21UserNameDesktopFontSize: '.4',
      fc21UserNamemobileFontSize: '.4',
      fcbTrendTotalValueTextFontFamily: 'HiraginoSansGBW3',
      fc21placeBetsFontSize: 20,
      fc21placeBetsFontFamily: 'HiraginoSansGBW3',
      paysContentFontSize: 12,
      percentageContentFontSize: 14,
      paysContentTop: 4,
      percentageContentTop: 22,
      menuFontFamily: 'Verdana-Bold',
      TN_pays_blank_position_16_Top: 452,
      TN_pays_blank_position_17_Top: 452,
      TN_pays_blank_position_16_Left: 90,
      TN_pays_blank_position_17_Left: 90,

      splitCard_13_top: 294,
      landscapeSplitCard_13_top: 294,
      landscapeTnimage_split_height: 572,
      tnimage_split_height: 572,
    };
  }

  public static get cs(): translateFontProp {
    return {
      fc21PortraitgameOverTextFontsize: 24,
      fcbfooterBetFontSize: 29,
      fcbhintTextFontSize: 22,
      fcbhintQuestionMarkNumberFontSize: 22,
      fcbspreadhintTextFontSize: 22,
      fcbfooterPaidFontSize: 16,
      fcbfooterCreditFontSize: 33,
      fcbTrendTextFontSize: 26,
      fcbTrendTextNameFontSize: 26,
      fcbTrendTextValueFontSize: 69,
      fcbTrendFooterValueFontSize: 17,
      fcbTrendHeaderFontSize: 34,
      fcbTrendShuffleTextFontSize: 28,
      fcbTrendTotalValueTextFontSize: 37,
      fcbTrendFooterValueKeyFontSize: 20,
      fcbTrendTextFontFamily: 'MyriadPro-Cond',
      footerBetFontFamily: 'MyriadPro-Cond',
      keyBoardTextFamily: 'MyriadPro-Cond',
      alertTextFontFamily: 'MyriadPro-Cond',
      footerPaidFontFamily: 'MyriadPro-Cond',
      footerCreditFontFamily: 'MyriadPro-Cond',
      fc21footerBetFontSize: 21,
      fc21footerPaidFontSize: 18,
      fc21footerCreditFontSize: 17,
      fcbaccaratbetLimitMinFontSize: 18,
      fcbaccaratbetLimitMaxFontSize: 18,
      fcbaccaratbetLimitMinFontFamily: 'MyriadPro-Bold',
      fcbaccaratbetLimitMaxFontFamily: 'MyriadPro-Bold',
      fc21betLimitMinFontSize: 17,
      fc21betLimitMinFontSizePortrait: 16,
      fc21betLimitMaxFontSize: 17,
      fc21betLimitMaxFontSizePortrait: 16,
      fc21betLimitMinFontFamily: 'MyriadPro-Bold',
      fc21betLimitMaxFontFamily: 'MyriadPro-Bold',
      fc21paysTextFontFamily: 'MyriadPro-BoldCond',
      fc21UserNameDesktopFontSize: '.5',
      fc21UserNamemobileFontSize: '.5',
      fcbTrendTotalValueTextFontFamily: 'MyriadPro-BoldCond',
      fc21placeBetsFontSize: 24,
      fc21placeBetsFontFamily: 'MyriadPro-Cond',
      paysContentFontSize: 15,
      percentageContentFontSize: 15,
      paysContentTop: 5,
      percentageContentTop: 20,
      menuFontFamily: 'Verdana-Bold',
      TN_pays_blank_position_16_Top: 451,
      TN_pays_blank_position_17_Top: 451,
      TN_pays_blank_position_16_Left: 88,
      TN_pays_blank_position_17_Left: 88,

      splitCard_13_top: 294,
      landscapeSplitCard_13_top: 294,
      landscapeTnimage_split_height: 572,
      tnimage_split_height: 572,
    };
  }

  public static get da(): translateFontProp {
    return {
      fc21PortraitgameOverTextFontsize: 23,
      fcbfooterBetFontSize: 33,
      fcbhintTextFontSize: 22,
      fcbhintQuestionMarkNumberFontSize: 22,
      fcbspreadhintTextFontSize: 22,
      fcbfooterPaidFontSize: 20,
      fcbfooterCreditFontSize: 33,
      fcbTrendTextFontSize: 26,
      fcbTrendTextNameFontSize: 26,
      fcbTrendTextValueFontSize: 69,
      fcbTrendFooterValueFontSize: 21,
      fcbTrendHeaderFontSize: 26,
      fcbTrendShuffleTextFontSize: 19,
      fcbTrendTotalValueTextFontSize: 30,
      fcbTrendFooterValueKeyFontSize: 20,
      fcbTrendTextFontFamily: 'MyriadPro-Cond',
      footerBetFontFamily: 'MyriadPro-Cond',
      keyBoardTextFamily: 'MyriadPro-Cond',
      alertTextFontFamily: 'MyriadPro-Cond',
      footerPaidFontFamily: 'MyriadPro-Cond',
      footerCreditFontFamily: 'MyriadPro-Cond',
      fc21footerBetFontSize: 21,
      fc21footerPaidFontSize: 20,
      fc21footerCreditFontSize: 21,
      fcbaccaratbetLimitMinFontSize: 20,
      fcbaccaratbetLimitMaxFontSize: 19,
      fcbaccaratbetLimitMinFontFamily: 'MyriadPro-Bold',
      fcbaccaratbetLimitMaxFontFamily: 'MyriadPro-Bold',
      fc21betLimitMinFontSize: 17,
      fc21betLimitMinFontSizePortrait: 18,
      fc21betLimitMaxFontSize: 17,
      fc21betLimitMaxFontSizePortrait: 18,
      fc21betLimitMinFontFamily: 'MyriadPro-Bold',
      fc21betLimitMaxFontFamily: 'MyriadPro-Bold',
      fc21paysTextFontFamily: 'SerpentineBold',
      fc21UserNameDesktopFontSize: '.4',
      fc21UserNamemobileFontSize: '.4',
      fcbTrendTotalValueTextFontFamily: 'SerpentineBold',
      fc21placeBetsFontSize: 22,
      fc21placeBetsFontFamily: 'MyriadPro-Cond',
      paysContentFontSize: 12,
      percentageContentFontSize: 15,
      paysContentTop: 7,
      percentageContentTop: 20,
      menuFontFamily: 'Verdana-Bold',
      TN_pays_blank_position_16_Top: 447,
      TN_pays_blank_position_17_Top: 452,
      TN_pays_blank_position_16_Left: 101,
      TN_pays_blank_position_17_Left: 101,

      splitCard_13_top: 294,
      landscapeSplitCard_13_top: 294,
      landscapeTnimage_split_height: 592,
      tnimage_split_height: 592,
    };
  }

  public static get nl(): translateFontProp {
    return {
      fc21PortraitgameOverTextFontsize: 24,
      fcbfooterBetFontSize: 33,
      fcbhintTextFontSize: 22,
      fcbhintQuestionMarkNumberFontSize: 22,
      fcbspreadhintTextFontSize: 20,
      fcbfooterPaidFontSize: 21,
      fcbfooterCreditFontSize: 33,
      fcbTrendTextFontSize: 26,
      fcbTrendTextNameFontSize: 26,
      fcbTrendTextValueFontSize: 69,
      fcbTrendFooterValueFontSize: 20,
      fcbTrendHeaderFontSize: 28,
      fcbTrendShuffleTextFontSize: 22,
      fcbTrendTotalValueTextFontSize: 30,
      fcbTrendFooterValueKeyFontSize: 20,
      fcbTrendTextFontFamily: 'MyriadPro-Cond',
      footerBetFontFamily: 'MyriadPro-Cond',
      keyBoardTextFamily: 'MyriadPro-Cond',
      alertTextFontFamily: 'MyriadPro-Cond',
      footerPaidFontFamily: 'MyriadPro-Cond',
      footerCreditFontFamily: 'MyriadPro-Cond',
      fc21footerBetFontSize: 21,
      fc21footerPaidFontSize: 21,
      fc21footerCreditFontSize: 20,
      fcbaccaratbetLimitMinFontSize: 20,
      fcbaccaratbetLimitMaxFontSize: 19,
      fcbaccaratbetLimitMinFontFamily: 'MyriadPro-Bold',
      fcbaccaratbetLimitMaxFontFamily: 'MyriadPro-Bold',
      fc21betLimitMinFontSize: 17,
      fc21betLimitMinFontSizePortrait: 17,
      fc21betLimitMaxFontSize: 17,
      fc21betLimitMaxFontSizePortrait: 17,
      fc21betLimitMinFontFamily: 'MyriadPro-Bold',
      fc21betLimitMaxFontFamily: 'MyriadPro-Bold',
      fc21paysTextFontFamily: 'SerpentineBold',
      fc21UserNameDesktopFontSize: '.4',
      fc21UserNamemobileFontSize: '.4',
      fcbTrendTotalValueTextFontFamily: 'SerpentineBold',
      fc21placeBetsFontSize: 22,
      fc21placeBetsFontFamily: 'MyriadPro-Cond',
      paysContentFontSize: 11,
      percentageContentFontSize: 14,
      paysContentTop: 6,
      percentageContentTop: 20,
      menuFontFamily: 'Verdana-Bold',
      TN_pays_blank_position_16_Top: 440,
      TN_pays_blank_position_17_Top: 440,
      TN_pays_blank_position_16_Left: 101,
      TN_pays_blank_position_17_Left: 101,

      splitCard_13_top: 294,
      landscapeSplitCard_13_top: 294,
      landscapeTnimage_split_height: 572,
      tnimage_split_height: 572,
    };
  }

  public static get en(): translateFontProp {
    return {
      fc21PortraitgameOverTextFontsize: 24,
      fcbfooterBetFontSize: 33,
      fcbhintTextFontSize: 22,
      fcbhintQuestionMarkNumberFontSize: 22,
      fcbspreadhintTextFontSize: 22,
      fcbfooterPaidFontSize: 33,
      fcbfooterCreditFontSize: 33,
      fcbTrendTextFontSize: 26,
      fcbTrendTextNameFontSize: 26,
      fcbTrendTextValueFontSize: 69,
      fcbTrendFooterValueFontSize: 20,
      fcbTrendHeaderFontSize: 30,
      fcbTrendShuffleTextFontSize: 24,
      fcbTrendTotalValueTextFontSize: 40,
      fcbTrendFooterValueKeyFontSize: 20,
      fcbTrendTextFontFamily: 'MyriadPro-BoldCond',
      footerBetFontFamily: 'MyriadPro-Cond',
      keyBoardTextFamily: 'Verdana-Bold',
      alertTextFontFamily: 'Verdana',
      footerPaidFontFamily: 'MyriadPro-Cond',
      footerCreditFontFamily: 'MyriadPro-Cond',
      fc21footerBetFontSize: 21,
      fc21footerPaidFontSize: 21,
      fc21footerCreditFontSize: 20,
      fcbaccaratbetLimitMinFontSize: 23,
      fcbaccaratbetLimitMaxFontSize: 23,
      fcbaccaratbetLimitMinFontFamily: 'MyriadPro-Bold',
      fcbaccaratbetLimitMaxFontFamily: 'MyriadPro-Bold',
      fc21betLimitMinFontSize: 17,
      fc21betLimitMinFontSizePortrait: 18,
      fc21betLimitMaxFontSize: 17,
      fc21betLimitMaxFontSizePortrait: 18,
      fc21betLimitMinFontFamily: 'MyriadPro-Bold',
      fc21betLimitMaxFontFamily: 'MyriadPro-Bold',
      fc21paysTextFontFamily: 'SerpentineBold',
      fc21UserNameDesktopFontSize: '.4',
      fc21UserNamemobileFontSize: '.4',
      fcbTrendTotalValueTextFontFamily: 'SerpentineBold',
      fc21placeBetsFontSize: 22,
      fc21placeBetsFontFamily: 'MyriadPro-Cond',
      paysContentFontSize: 15,
      percentageContentFontSize: 15,
      paysContentTop: 4,
      percentageContentTop: 20,
      menuFontFamily: 'Verdana-Bold',
      TN_pays_blank_position_16_Top: 440,
      TN_pays_blank_position_17_Top: 440,
      TN_pays_blank_position_16_Left: 101,
      TN_pays_blank_position_17_Left: 101,

      splitCard_13_top: 280,
      landscapeSplitCard_13_top: 280,
      landscapeTnimage_split_height: 572,
      tnimage_split_height: 572,
    };
  }

  public static get fi(): translateFontProp {
    return {
      fc21PortraitgameOverTextFontsize: 24,
      fcbfooterBetFontSize: 30,
      fcbhintTextFontSize: 22,
      fcbhintQuestionMarkNumberFontSize: 22,
      fcbspreadhintTextFontSize: 22,
      fcbfooterPaidFontSize: 18,
      fcbfooterCreditFontSize: 30,
      fcbTrendTextFontSize: 26,
      fcbTrendTextNameFontSize: 26,
      fcbTrendTextValueFontSize: 69,
      fcbTrendFooterValueFontSize: 14,
      fcbTrendHeaderFontSize: 30,
      fcbTrendShuffleTextFontSize: 17,
      fcbTrendTotalValueTextFontSize: 36,
      fcbTrendFooterValueKeyFontSize: 20,
      fcbTrendTextFontFamily: 'MyriadPro-BoldCond',
      footerBetFontFamily: 'MyriadPro-Cond',
      keyBoardTextFamily: 'MyriadPro-Cond',
      alertTextFontFamily: 'MyriadPro-Cond',
      footerPaidFontFamily: 'MyriadPro-Cond',
      footerCreditFontFamily: 'MyriadPro-Cond',
      fc21footerBetFontSize: 21,
      fc21footerPaidFontSize: 19,
      fc21footerCreditFontSize: 14,
      fcbaccaratbetLimitMinFontSize: 21,
      fcbaccaratbetLimitMaxFontSize: 20,
      fcbaccaratbetLimitMinFontFamily: 'MyriadPro-Bold',
      fcbaccaratbetLimitMaxFontFamily: 'MyriadPro-Bold',
      fc21betLimitMinFontSize: 17,
      fc21betLimitMinFontSizePortrait: 17,
      fc21betLimitMaxFontSize: 17,
      fc21betLimitMaxFontSizePortrait: 17,
      fc21betLimitMinFontFamily: 'MyriadPro-Bold',
      fc21betLimitMaxFontFamily: 'MyriadPro-Bold',
      fc21paysTextFontFamily: 'SerpentineBold',
      fc21UserNameDesktopFontSize: '.4',
      fc21UserNamemobileFontSize: '.4',
      fcbTrendTotalValueTextFontFamily: 'MyriadPro-BoldCond',
      fc21placeBetsFontSize: 22,
      fc21placeBetsFontFamily: 'MyriadPro-Cond',
      paysContentFontSize: 12,
      percentageContentFontSize: 15,
      paysContentTop: 5,
      percentageContentTop: 20,
      menuFontFamily: 'Verdana-Bold',
      TN_pays_blank_position_16_Top: 464,
      TN_pays_blank_position_17_Top: 464,
      TN_pays_blank_position_16_Left: 86,
      TN_pays_blank_position_17_Left: 86,

      splitCard_13_top: 294,
      landscapeSplitCard_13_top: 294,
      landscapeTnimage_split_height: 572,
      tnimage_split_height: 572,
    };
  }

  public static get fr(): translateFontProp {
    return {
      fc21PortraitgameOverTextFontsize: 24,
      fcbfooterBetFontSize: 33,
      fcbhintTextFontSize: 18,
      fcbhintQuestionMarkNumberFontSize: 18,
      fcbspreadhintTextFontSize: 17,
      fcbfooterPaidFontSize: 33,
      fcbfooterCreditFontSize: 33,
      fcbTrendTextFontSize: 26,
      fcbTrendTextNameFontSize: 26,
      fcbTrendTextValueFontSize: 69,
      fcbTrendFooterValueFontSize: 20,
      fcbTrendHeaderFontSize: 20,
      fcbTrendShuffleTextFontSize: 21,
      fcbTrendTotalValueTextFontSize: 28,
      fcbTrendFooterValueKeyFontSize: 20,
      fcbTrendTextFontFamily: 'MyriadPro-BoldCond',
      footerBetFontFamily: 'MyriadPro-Cond',
      keyBoardTextFamily: 'MyriadPro-Cond',
      alertTextFontFamily: 'MyriadPro-Cond',
      footerPaidFontFamily: 'MyriadPro-Cond',
      footerCreditFontFamily: 'MyriadPro-Cond',
      fc21footerBetFontSize: 21,
      fc21footerPaidFontSize: 21,
      fc21footerCreditFontSize: 20,
      fcbaccaratbetLimitMinFontSize: 21,
      fcbaccaratbetLimitMaxFontSize: 21,
      fcbaccaratbetLimitMinFontFamily: 'MyriadPro-Bold',
      fcbaccaratbetLimitMaxFontFamily: 'MyriadPro-Bold',
      fc21betLimitMinFontSize: 17,
      fc21betLimitMinFontSizePortrait: 17,
      fc21betLimitMaxFontSize: 17,
      fc21betLimitMaxFontSizePortrait: 17,
      fc21betLimitMinFontFamily: 'MyriadPro-Bold',
      fc21betLimitMaxFontFamily: 'MyriadPro-Bold',
      fc21paysTextFontFamily: 'SerpentineBold',
      fc21UserNameDesktopFontSize: '.4',
      fc21UserNamemobileFontSize: '.4',
      fcbTrendTotalValueTextFontFamily: 'SerpentineBold',
      fc21placeBetsFontSize: 21,
      fc21placeBetsFontFamily: 'MyriadPro-Cond',
      paysContentFontSize: 12,
      percentageContentFontSize: 15,
      paysContentTop: 5,
      percentageContentTop: 20,
      menuFontFamily: 'Verdana-Bold',
      TN_pays_blank_position_16_Top: 458,
      TN_pays_blank_position_17_Top: 458,
      TN_pays_blank_position_16_Left: 79,
      TN_pays_blank_position_17_Left: 79,

      splitCard_13_top: 294,
      landscapeSplitCard_13_top: 294,
      landscapeTnimage_split_height: 572,
      tnimage_split_height: 572,
    };
  }

  public static get de(): translateFontProp {
    return {
      fc21PortraitgameOverTextFontsize: 24,
      fcbfooterBetFontSize: 28,
      fcbhintTextFontSize: 22,
      fcbhintQuestionMarkNumberFontSize: 22,
      fcbspreadhintTextFontSize: 21,
      fcbfooterPaidFontSize: 15,
      fcbfooterCreditFontSize: 24,
      fcbTrendTextFontSize: 26,
      fcbTrendTextNameFontSize: 26,
      fcbTrendTextValueFontSize: 69,
      fcbTrendFooterValueFontSize: 12,
      fcbTrendHeaderFontSize: 29,
      fcbTrendShuffleTextFontSize: 24,
      fcbTrendTotalValueTextFontSize: 36,
      fcbTrendFooterValueKeyFontSize: 20,
      fcbTrendTextFontFamily: 'MyriadPro-BoldCond',
      footerBetFontFamily: 'MyriadPro-Cond',
      keyBoardTextFamily: 'MyriadPro-Cond',
      alertTextFontFamily: 'MyriadPro-Cond',
      footerPaidFontFamily: 'MyriadPro-Cond',
      footerCreditFontFamily: 'MyriadPro-Cond',
      fc21footerBetFontSize: 21,
      fc21footerPaidFontSize: 15,
      fc21footerCreditFontSize: 12,
      fcbaccaratbetLimitMinFontSize: 18,
      fcbaccaratbetLimitMaxFontSize: 18,
      fcbaccaratbetLimitMinFontFamily: 'MyriadPro-Bold',
      fcbaccaratbetLimitMaxFontFamily: 'MyriadPro-Bold',
      fc21betLimitMinFontSize: 17,
      fc21betLimitMinFontSizePortrait: 17,
      fc21betLimitMaxFontSize: 17,
      fc21betLimitMaxFontSizePortrait: 17,
      fc21betLimitMinFontFamily: 'MyriadPro-Bold',
      fc21betLimitMaxFontFamily: 'MyriadPro-Bold',
      fc21paysTextFontFamily: 'SerpentineBold',
      fc21UserNameDesktopFontSize: '.4',
      fc21UserNamemobileFontSize: '.4',
      fcbTrendTotalValueTextFontFamily: 'MyriadPro-BoldCond',
      fc21placeBetsFontSize: 22,
      fc21placeBetsFontFamily: 'MyriadPro-Cond',
      paysContentFontSize: 12,
      percentageContentFontSize: 15,
      paysContentTop: 5,
      percentageContentTop: 20,
      menuFontFamily: 'Verdana-Bold',
      TN_pays_blank_position_16_Top: 452,
      TN_pays_blank_position_17_Top: 452,
      TN_pays_blank_position_16_Left: 90,
      TN_pays_blank_position_17_Left: 90,

      splitCard_13_top: 294,
      landscapeSplitCard_13_top: 294,
      landscapeTnimage_split_height: 596,
      tnimage_split_height: 596,
    };
  }

  public static get he(): translateFontProp {
    return {
      fc21PortraitgameOverTextFontsize: 24,
      fcbfooterBetFontSize: 33,
      fcbhintTextFontSize: 22,
      fcbhintQuestionMarkNumberFontSize: 22,
      fcbspreadhintTextFontSize: 22,
      fcbfooterPaidFontSize: 33,
      fcbfooterCreditFontSize: 33,
      fcbTrendTextFontSize: 26,
      fcbTrendTextNameFontSize: 26,
      fcbTrendTextValueFontSize: 69,
      fcbTrendFooterValueFontSize: 25,
      fcbTrendHeaderFontSize: 30,
      fcbTrendShuffleTextFontSize: 24,
      fcbTrendTotalValueTextFontSize: 40,
      fcbTrendFooterValueKeyFontSize: 20,
      fcbTrendTextFontFamily: 'Adobe-Hebrew',
      footerBetFontFamily: 'Adobe-Hebrew',
      keyBoardTextFamily: 'Adobe-Hebrew',
      alertTextFontFamily: 'Adobe-Hebrew',
      footerPaidFontFamily: 'Adobe-Hebrew',
      footerCreditFontFamily: 'Adobe-Hebrew',
      fc21footerBetFontSize: 25,
      fc21footerPaidFontSize: 25,
      fc21footerCreditFontSize: 25,
      fcbaccaratbetLimitMinFontSize: 20,
      fcbaccaratbetLimitMaxFontSize: 20,
      fcbaccaratbetLimitMinFontFamily: 'Adobe-Hebrew',
      fcbaccaratbetLimitMaxFontFamily: 'Adobe-Hebrew',
      fc21betLimitMinFontSize: 18,
      fc21betLimitMinFontSizePortrait: 18,
      fc21betLimitMaxFontSize: 18,
      fc21betLimitMaxFontSizePortrait: 18,
      fc21betLimitMinFontFamily: 'Adobe-Hebrew',
      fc21betLimitMaxFontFamily: 'Adobe-Hebrew',
      fc21paysTextFontFamily: 'ArialHebrew-Bold',
      fc21UserNameDesktopFontSize: '.45',
      fc21UserNamemobileFontSize: '.45',
      fcbTrendTotalValueTextFontFamily: 'ArialHebrew-Bold',
      fc21placeBetsFontSize: 24,
      fc21placeBetsFontFamily: 'Adobe-Hebrew',
      paysContentFontSize: 19,
      percentageContentFontSize: 19,
      paysContentTop: 4,
      percentageContentTop: 20,
      menuFontFamily: 'Adobe-Hebrew',
      TN_pays_blank_position_16_Top: 490,
      TN_pays_blank_position_17_Top: 490,
      TN_pays_blank_position_16_Left: 606,
      TN_pays_blank_position_17_Left: 606,

      splitCard_13_top: 294,
      landscapeSplitCard_13_top: 294,
      landscapeTnimage_split_height: 572,
      tnimage_split_height: 572,
    };
  }

  public static get id(): translateFontProp {
    return {
      fc21PortraitgameOverTextFontsize: 24,
      fcbfooterBetFontSize: 20,
      fcbhintTextFontSize: 18,
      fcbhintQuestionMarkNumberFontSize: 18,
      fcbspreadhintTextFontSize: 20,
      fcbfooterPaidFontSize: 19,
      fcbfooterCreditFontSize: 33,
      fcbTrendTextFontSize: 26,
      fcbTrendTextNameFontSize: 26,
      fcbTrendTextValueFontSize: 69,
      fcbTrendFooterValueFontSize: 21,
      fcbTrendHeaderFontSize: 33,
      fcbTrendShuffleTextFontSize: 33,
      fcbTrendTotalValueTextFontSize: 36,
      fcbTrendFooterValueKeyFontSize: 20,
      fcbTrendTextFontFamily: 'MyriadPro-BoldCond',
      footerBetFontFamily: 'MyriadPro-Cond',
      keyBoardTextFamily: 'MyriadPro-Cond',
      alertTextFontFamily: 'MyriadPro-Cond',
      footerPaidFontFamily: 'MyriadPro-Cond',
      footerCreditFontFamily: 'MyriadPro-Cond',
      fc21footerBetFontSize: 19,
      fc21footerPaidFontSize: 20,
      fc21footerCreditFontSize: 21,
      fcbaccaratbetLimitMinFontSize: 21,
      fcbaccaratbetLimitMaxFontSize: 20,
      fcbaccaratbetLimitMinFontFamily: 'MyriadPro-BoldCond',
      fcbaccaratbetLimitMaxFontFamily: 'MyriadPro-BoldCond',
      fc21betLimitMinFontSize: 16,
      fc21betLimitMinFontSizePortrait: 17,
      fc21betLimitMaxFontSize: 16,
      fc21betLimitMaxFontSizePortrait: 17,
      fc21betLimitMinFontFamily: 'MyriadPro-BoldCond',
      fc21betLimitMaxFontFamily: 'MyriadPro-BoldCond',
      fc21paysTextFontFamily: 'SerpentineBold',
      fc21UserNameDesktopFontSize: '.4',
      fc21UserNamemobileFontSize: '.4',
      fcbTrendTotalValueTextFontFamily: 'MyriadPro-BoldCond',
      fc21placeBetsFontSize: 20,
      fc21placeBetsFontFamily: 'MyriadPro-Cond',
      paysContentFontSize: 14,
      percentageContentFontSize: 15,
      paysContentTop: 4,
      percentageContentTop: 21,
      menuFontFamily: 'Verdana-Bold',
      TN_pays_blank_position_16_Top: 453,
      TN_pays_blank_position_17_Top: 453,
      TN_pays_blank_position_16_Left: 101,
      TN_pays_blank_position_17_Left: 101,

      splitCard_13_top: 294,
      landscapeSplitCard_13_top: 294,
      landscapeTnimage_split_height: 593,
      tnimage_split_height: 593,
    };
  }

  public static get it(): translateFontProp {
    return {
      fc21PortraitgameOverTextFontsize: 24,
      fcbfooterBetFontSize: 22,
      fcbhintTextFontSize: 17,
      fcbhintQuestionMarkNumberFontSize: 17,
      fcbspreadhintTextFontSize: 18,
      fcbfooterPaidFontSize: 26,
      fcbfooterCreditFontSize: 33,
      fcbTrendTextFontSize: 26,
      fcbTrendTextNameFontSize: 26,
      fcbTrendTextValueFontSize: 69,
      fcbTrendFooterValueFontSize: 21,
      fcbTrendHeaderFontSize: 30,
      fcbTrendShuffleTextFontSize: 24,
      fcbTrendTotalValueTextFontSize: 37,
      fcbTrendFooterValueKeyFontSize: 20,
      fcbTrendTextFontFamily: 'MyriadPro-BoldCond',
      footerBetFontFamily: 'MyriadPro-Cond',
      keyBoardTextFamily: 'MyriadPro-Cond',
      alertTextFontFamily: 'MyriadPro-Cond',
      footerPaidFontFamily: 'MyriadPro-Cond',
      footerCreditFontFamily: 'MyriadPro-Cond',
      fc21footerBetFontSize: 20,
      fc21footerPaidFontSize: 21,
      fc21footerCreditFontSize: 21,
      fcbaccaratbetLimitMinFontSize: 21,
      fcbaccaratbetLimitMaxFontSize: 20,
      fcbaccaratbetLimitMinFontFamily: 'MyriadPro-Bold',
      fcbaccaratbetLimitMaxFontFamily: 'MyriadPro-Bold',
      fc21betLimitMinFontSize: 17,
      fc21betLimitMinFontSizePortrait: 17,
      fc21betLimitMaxFontSize: 17,
      fc21betLimitMaxFontSizePortrait: 17,
      fc21betLimitMinFontFamily: 'MyriadPro-Bold',
      fc21betLimitMaxFontFamily: 'MyriadPro-Bold',
      fc21paysTextFontFamily: 'SerpentineBold',
      fc21UserNameDesktopFontSize: '.4',
      fc21UserNamemobileFontSize: '.4',
      fcbTrendTotalValueTextFontFamily: 'MyriadPro-BoldCond',
      fc21placeBetsFontSize: 17,
      fc21placeBetsFontFamily: 'MyriadPro-Cond',
      paysContentFontSize: 16,
      percentageContentFontSize: 15,
      paysContentTop: 3,
      percentageContentTop: 21,
      menuFontFamily: 'Verdana-Bold',
      TN_pays_blank_position_16_Top: 459,
      TN_pays_blank_position_17_Top: 459,
      TN_pays_blank_position_16_Left: 90,
      TN_pays_blank_position_17_Left: 90,

      splitCard_13_top: 294,
      landscapeSplitCard_13_top: 294,
      landscapeTnimage_split_height: 572,
      tnimage_split_height: 572,
    };
  }

  public static get ja(): translateFontProp {
    return {
      fc21PortraitgameOverTextFontsize: 24,
      fcbfooterBetFontSize: 20,
      fcbhintTextFontSize: 22,
      fcbhintQuestionMarkNumberFontSize: 22,
      fcbspreadhintTextFontSize: 22,
      fcbfooterPaidFontSize: 20,
      fcbfooterCreditFontSize: 20,
      fcbTrendTextFontSize: 26,
      fcbTrendTextNameFontSize: 26,
      fcbTrendTextValueFontSize: 69,
      fcbTrendFooterValueFontSize: 17,
      fcbTrendHeaderFontSize: 30,
      fcbTrendShuffleTextFontSize: 19,
      fcbTrendTotalValueTextFontSize: 35,
      fcbTrendFooterValueKeyFontSize: 20,
      fcbTrendTextFontFamily: 'HiraginoSansGBW3',
      footerBetFontFamily: 'HiraginoSansGBW3',
      keyBoardTextFamily: 'HiraginoSansGBW3',
      alertTextFontFamily: 'HiraginoSansGBW3',
      footerPaidFontFamily: 'HiraginoSansGBW3',
      footerCreditFontFamily: 'HiraginoSansGBW3',
      fc21footerBetFontSize: 21,
      fc21footerPaidFontSize: 21,
      fc21footerCreditFontSize: 17,
      fcbaccaratbetLimitMinFontSize: 16,
      fcbaccaratbetLimitMaxFontSize: 16,
      fcbaccaratbetLimitMinFontFamily: 'Adobe 고딕 Std',
      fcbaccaratbetLimitMaxFontFamily: 'Adobe 고딕 Std',
      fc21betLimitMinFontSize: 17,
      fc21betLimitMinFontSizePortrait: 17,
      fc21betLimitMaxFontSize: 17,
      fc21betLimitMaxFontSizePortrait: 17,
      fc21betLimitMinFontFamily: 'Adobe 고딕 Std',
      fc21betLimitMaxFontFamily: 'Adobe 고딕 Std',
      fc21paysTextFontFamily: 'Adobe 고딕 Std',
      fc21UserNameDesktopFontSize: '.5',
      fc21UserNamemobileFontSize: '.5',
      fcbTrendTotalValueTextFontFamily: 'Adobe 고딕 Std',
      fc21placeBetsFontSize: 18,
      fc21placeBetsFontFamily: 'HiraginoSansGBW3',
      paysContentFontSize: 13,
      percentageContentFontSize: 16,
      paysContentTop: 5,
      percentageContentTop: 20,
      menuFontFamily: 'Verdana-Bold',
      TN_pays_blank_position_16_Top: 468,
      TN_pays_blank_position_17_Top: 468,
      TN_pays_blank_position_16_Left: 88,
      TN_pays_blank_position_17_Left: 88,

      splitCard_13_top: 294,
      landscapeSplitCard_13_top: 294,
      landscapeTnimage_split_height: 572,
      tnimage_split_height: 572,
    };
  }

  public static get ko(): translateFontProp {
    return {
      fc21PortraitgameOverTextFontsize: 24,
      fcbfooterBetFontSize: 29,
      fcbhintTextFontSize: 22,
      fcbhintQuestionMarkNumberFontSize: 22,
      fcbspreadhintTextFontSize: 22,
      fcbfooterPaidFontSize: 29,
      fcbfooterCreditFontSize: 29,
      fcbTrendTextFontSize: 26,
      fcbTrendTextNameFontSize: 26,
      fcbTrendTextValueFontSize: 69,
      fcbTrendFooterValueFontSize: 21,
      fcbTrendHeaderFontSize: 30,
      fcbTrendShuffleTextFontSize: 24,
      fcbTrendTotalValueTextFontSize: 35,
      fcbTrendFooterValueKeyFontSize: 20,
      fcbTrendTextFontFamily: 'Adobe 고딕 Std',
      footerBetFontFamily: 'Adobe 고딕 Std',
      keyBoardTextFamily: 'Adobe 고딕 Std',
      alertTextFontFamily: 'Adobe 고딕 Std',
      footerPaidFontFamily: 'Adobe 고딕 Std',
      footerCreditFontFamily: 'Adobe 고딕 Std',
      fc21footerBetFontSize: 21,
      fc21footerPaidFontSize: 21,
      fc21footerCreditFontSize: 21,
      fcbaccaratbetLimitMinFontSize: 18,
      fcbaccaratbetLimitMaxFontSize: 18,
      fcbaccaratbetLimitMinFontFamily: 'Adobe 고딕 Std',
      fcbaccaratbetLimitMaxFontFamily: 'Adobe 고딕 Std',
      fc21betLimitMinFontSize: 17,
      fc21betLimitMinFontSizePortrait: 17,
      fc21betLimitMaxFontSize: 17,
      fc21betLimitMaxFontSizePortrait: 17,
      fc21betLimitMinFontFamily: 'Adobe 고딕 Std',
      fc21betLimitMaxFontFamily: 'Adobe 고딕 Std',
      fc21paysTextFontFamily: 'Adobe 고딕 Std',
      fc21UserNameDesktopFontSize: '.5',
      fc21UserNamemobileFontSize: '.5',
      fcbTrendTotalValueTextFontFamily: 'Adobe 고딕 Std',
      fc21placeBetsFontSize: 19,
      fc21placeBetsFontFamily: 'Adobe 고딕 Std',
      paysContentFontSize: 13,
      percentageContentFontSize: 16,
      paysContentTop: 5,
      percentageContentTop: 20,
      menuFontFamily: 'Verdana-Bold',
      TN_pays_blank_position_16_Top: 462,
      TN_pays_blank_position_17_Top: 462,
      TN_pays_blank_position_16_Left: 101,
      TN_pays_blank_position_17_Left: 101,

      splitCard_13_top: 294,
      landscapeSplitCard_13_top: 294,
      landscapeTnimage_split_height: 572,
      tnimage_split_height: 572,
    };
  }

  public static get nb(): translateFontProp {
    return {
      fc21PortraitgameOverTextFontsize: 22,
      fcbfooterBetFontSize: 30,
      fcbhintTextFontSize: 22,
      fcbhintQuestionMarkNumberFontSize: 22,
      fcbspreadhintTextFontSize: 20,
      fcbfooterPaidFontSize: 28,
      fcbfooterCreditFontSize: 26,
      fcbTrendTextFontSize: 26,
      fcbTrendTextNameFontSize: 26,
      fcbTrendTextValueFontSize: 69,
      fcbTrendFooterValueFontSize: 12,
      fcbTrendHeaderFontSize: 28,
      fcbTrendShuffleTextFontSize: 19,
      fcbTrendTotalValueTextFontSize: 33,
      fcbTrendFooterValueKeyFontSize: 20,
      fcbTrendTextFontFamily: 'MyriadPro-BoldCond',
      footerBetFontFamily: 'MyriadPro-Cond',
      keyBoardTextFamily: 'MyriadPro-Cond',
      alertTextFontFamily: 'MyriadPro-Cond',
      footerPaidFontFamily: 'MyriadPro-Cond',
      footerCreditFontFamily: 'MyriadPro-Cond',
      fc21footerBetFontSize: 21,
      fc21footerPaidFontSize: 21,
      fc21footerCreditFontSize: 12,
      fcbaccaratbetLimitMinFontSize: 21,
      fcbaccaratbetLimitMaxFontSize: 20,
      fcbaccaratbetLimitMinFontFamily: 'MyriadPro-Bold',
      fcbaccaratbetLimitMaxFontFamily: 'MyriadPro-Bold',
      fc21betLimitMinFontSize: 17,
      fc21betLimitMinFontSizePortrait: 17,
      fc21betLimitMaxFontSize: 17,
      fc21betLimitMaxFontSizePortrait: 17,
      fc21betLimitMinFontFamily: 'MyriadPro-Bold',
      fc21betLimitMaxFontFamily: 'MyriadPro-Bold',
      fc21paysTextFontFamily: 'SerpentineBold',
      fc21UserNameDesktopFontSize: '.4',
      fc21UserNamemobileFontSize: '.4',
      fcbTrendTotalValueTextFontFamily: 'SerpentineBold',
      fc21placeBetsFontSize: 22,
      fc21placeBetsFontFamily: 'MyriadPro-Cond',
      paysContentFontSize: 12,
      percentageContentFontSize: 15,
      paysContentTop: 5,
      percentageContentTop: 20,
      menuFontFamily: 'Verdana-Bold',
      TN_pays_blank_position_16_Top: 440,
      TN_pays_blank_position_17_Top: 440,
      TN_pays_blank_position_16_Left: 101,
      TN_pays_blank_position_17_Left: 101,

      splitCard_13_top: 294,
      landscapeSplitCard_13_top: 294,
      landscapeTnimage_split_height: 572,
      tnimage_split_height: 572,
    };
  }

  public static get pl(): translateFontProp {
    return {
      fc21PortraitgameOverTextFontsize: 24,
      fcbfooterBetFontSize: 23,
      fcbhintTextFontSize: 22,
      fcbhintQuestionMarkNumberFontSize: 22,
      fcbspreadhintTextFontSize: 22,
      fcbfooterPaidFontSize: 21,
      fcbfooterCreditFontSize: 33,
      fcbTrendTextFontSize: 26,
      fcbTrendTextNameFontSize: 26,
      fcbTrendTextValueFontSize: 69,
      fcbTrendFooterValueFontSize: 17,
      fcbTrendHeaderFontSize: 30,
      fcbTrendShuffleTextFontSize: 30,
      fcbTrendTotalValueTextFontSize: 37,
      fcbTrendFooterValueKeyFontSize: 20,
      fcbTrendTextFontFamily: 'MyriadPro-BoldCond',
      footerBetFontFamily: 'MyriadPro-Cond',
      keyBoardTextFamily: 'MyriadPro-Cond',
      alertTextFontFamily: 'MyriadPro-Cond',
      footerPaidFontFamily: 'MyriadPro-Cond',
      footerCreditFontFamily: 'MyriadPro-Cond',
      fc21footerBetFontSize: 21,
      fc21footerPaidFontSize: 21,
      fc21footerCreditFontSize: 17,
      fcbaccaratbetLimitMinFontSize: 16,
      fcbaccaratbetLimitMaxFontSize: 16,
      fcbaccaratbetLimitMinFontFamily: 'MyriadPro-Bold',
      fcbaccaratbetLimitMaxFontFamily: 'MyriadPro-Bold',
      fc21betLimitMinFontSize: 18,
      fc21betLimitMinFontSizePortrait: 18,
      fc21betLimitMaxFontSize: 18,
      fc21betLimitMaxFontSizePortrait: 18,
      fc21betLimitMinFontFamily: 'MyriadPro-Bold',
      fc21betLimitMaxFontFamily: 'MyriadPro-Bold',
      fc21paysTextFontFamily: 'Verdana-Bold',
      fc21UserNameDesktopFontSize: '.5',
      fc21UserNamemobileFontSize: '.5',
      fcbTrendTotalValueTextFontFamily: 'MyriadPro-BoldCond',
      fc21placeBetsFontSize: 19,
      fc21placeBetsFontFamily: 'MyriadPro-Cond',
      paysContentFontSize: 12,
      percentageContentFontSize: 14,
      paysContentTop: 5,
      percentageContentTop: 20,
      menuFontFamily: 'Verdana-Bold',
      TN_pays_blank_position_16_Top: 455,
      TN_pays_blank_position_17_Top: 455,
      TN_pays_blank_position_16_Left: 101,
      TN_pays_blank_position_17_Left: 101,

      splitCard_13_top: 294,
      landscapeSplitCard_13_top: 294,
      landscapeTnimage_split_height: 572,
      tnimage_split_height: 572,
    };
  }

  public static get 'pt-BR'(): translateFontProp {
    return {
      fc21PortraitgameOverTextFontsize: 24,
      fcbfooterBetFontSize: 21,
      fcbhintTextFontSize: 17,
      fcbhintQuestionMarkNumberFontSize: 17,
      fcbspreadhintTextFontSize: 18,
      fcbfooterPaidFontSize: 33,
      fcbfooterCreditFontSize: 33,
      fcbTrendTextFontSize: 26,
      fcbTrendTextNameFontSize: 26,
      fcbTrendTextValueFontSize: 69,
      fcbTrendFooterValueFontSize: 17,
      fcbTrendHeaderFontSize: 30,
      fcbTrendShuffleTextFontSize: 19,
      fcbTrendTotalValueTextFontSize: 40,
      fcbTrendFooterValueKeyFontSize: 20,
      fcbTrendTextFontFamily: 'MyriadPro-BoldCond',
      footerBetFontFamily: 'MyriadPro-Cond',
      keyBoardTextFamily: 'MyriadPro-Cond',
      alertTextFontFamily: 'MyriadPro-Cond',
      footerPaidFontFamily: 'MyriadPro-Cond',
      footerCreditFontFamily: 'MyriadPro-Cond',
      fc21footerBetFontSize: 20,
      fc21footerPaidFontSize: 21,
      fc21footerCreditFontSize: 17,
      fcbaccaratbetLimitMinFontSize: 16,
      fcbaccaratbetLimitMaxFontSize: 16,
      fcbaccaratbetLimitMinFontFamily: 'MyriadPro-Bold', // Serpentine Bold
      fcbaccaratbetLimitMaxFontFamily: 'MyriadPro-Bold', // Serpentine Bold
      fc21betLimitMinFontSize: 17,
      fc21betLimitMinFontSizePortrait: 17,
      fc21betLimitMaxFontSize: 17,
      fc21betLimitMaxFontSizePortrait: 17,
      fc21betLimitMinFontFamily: 'MyriadPro-Bold', // Serpentine Bold
      fc21betLimitMaxFontFamily: 'MyriadPro-Bold', // Serpentine Bold
      fc21paysTextFontFamily: 'Verdana-Bold', // Serpentine Bold
      fc21UserNameDesktopFontSize: '.5',
      fc21UserNamemobileFontSize: '.5',
      fcbTrendTotalValueTextFontFamily: 'MyriadPro-BoldCond', // Serpentine Bold
      fc21placeBetsFontSize: 20,
      fc21placeBetsFontFamily: 'MyriadPro-Cond',
      paysContentFontSize: 12,
      percentageContentFontSize: 14,
      paysContentTop: 5,
      percentageContentTop: 20,
      menuFontFamily: 'Verdana-Bold',
      TN_pays_blank_position_16_Top: 459,
      TN_pays_blank_position_17_Top: 459,
      TN_pays_blank_position_16_Left: 101,
      TN_pays_blank_position_17_Left: 101,

      splitCard_13_top: 294,
      landscapeSplitCard_13_top: 294,
      landscapeTnimage_split_height: 572,
      tnimage_split_height: 572,
    };
  }

  public static get ru(): translateFontProp {
    return {
      fc21PortraitgameOverTextFontsize: 24,
      fcbfooterBetFontSize: 24,
      fcbhintTextFontSize: 20,
      fcbhintQuestionMarkNumberFontSize: 20,
      fcbspreadhintTextFontSize: 22,
      fcbfooterPaidFontSize: 18,
      fcbfooterCreditFontSize: 33,
      fcbTrendTextFontSize: 26,
      fcbTrendTextNameFontSize: 26,
      fcbTrendTextValueFontSize: 69,
      fcbTrendFooterValueFontSize: 17,
      fcbTrendHeaderFontSize: 20,
      fcbTrendShuffleTextFontSize: 24,
      fcbTrendTotalValueTextFontSize: 38,
      fcbTrendFooterValueKeyFontSize: 20,
      fcbTrendTextFontFamily: 'MyriadPro-BoldCond',
      footerBetFontFamily: 'MyriadPro-Cond',
      keyBoardTextFamily: 'MyriadPro-Cond',
      alertTextFontFamily: 'MyriadPro-Cond',
      footerPaidFontFamily: 'MyriadPro-Cond',
      footerCreditFontFamily: 'MyriadPro-Cond',
      fc21footerBetFontSize: 21,
      fc21footerPaidFontSize: 19,
      fc21footerCreditFontSize: 17,
      fcbaccaratbetLimitMinFontSize: 16,
      fcbaccaratbetLimitMaxFontSize: 16,
      fcbaccaratbetLimitMinFontFamily: 'MyriadPro-Bold', //Myriad Pro Black
      fcbaccaratbetLimitMaxFontFamily: 'MyriadPro-Bold', //Myriad Pro Black
      fc21betLimitMinFontSize: 17,
      fc21betLimitMinFontSizePortrait: 17,
      fc21betLimitMaxFontSize: 17,
      fc21betLimitMaxFontSizePortrait: 17,
      fc21betLimitMinFontFamily: 'MyriadPro-Bold', //Myriad Pro Black
      fc21betLimitMaxFontFamily: 'MyriadPro-Bold', //Myriad Pro Black
      fc21paysTextFontFamily: 'DejaVuSans-Bold', //Myriad Pro Black
      fc21UserNameDesktopFontSize: '.5',
      fc21UserNamemobileFontSize: '.5',
      fcbTrendTotalValueTextFontFamily: 'MyriadPro-BoldCond', //Myriad Pro Black
      fc21placeBetsFontSize: 23,
      fc21placeBetsFontFamily: 'MyriadPro-Cond',
      paysContentFontSize: 11,
      percentageContentFontSize: 14,
      paysContentTop: 5,
      percentageContentTop: 20,
      menuFontFamily: 'Verdana-Bold',
      TN_pays_blank_position_16_Top: 459,
      TN_pays_blank_position_17_Top: 461,
      TN_pays_blank_position_16_Left: 78,
      TN_pays_blank_position_17_Left: 101,

      splitCard_13_top: 294,
      landscapeSplitCard_13_top: 294,
      landscapeTnimage_split_height: 572,
      tnimage_split_height: 572,
    };
  }

  public static get es(): translateFontProp {
    return {
      fc21PortraitgameOverTextFontsize: 24,
      fcbfooterBetFontSize: 21,
      fcbhintTextFontSize: 18,
      fcbhintQuestionMarkNumberFontSize: 18,
      fcbspreadhintTextFontSize: 18,
      fcbfooterPaidFontSize: 24,
      fcbfooterCreditFontSize: 33,
      fcbTrendTextFontSize: 26,
      fcbTrendTextNameFontSize: 26,
      fcbTrendTextValueFontSize: 69,
      fcbTrendFooterValueFontSize: 17,
      fcbTrendHeaderFontSize: 33,
      fcbTrendShuffleTextFontSize: 33,
      fcbTrendTotalValueTextFontSize: 40,
      fcbTrendFooterValueKeyFontSize: 20,
      fcbTrendTextFontFamily: 'MyriadPro-BoldCond',
      footerBetFontFamily: 'MyriadPro-Cond',
      keyBoardTextFamily: 'MyriadPro-Cond',
      alertTextFontFamily: 'MyriadPro-Cond',
      footerPaidFontFamily: 'MyriadPro-Cond',
      footerCreditFontFamily: 'MyriadPro-Cond',
      fc21footerBetFontSize: 20,
      fc21footerPaidFontSize: 21,
      fc21footerCreditFontSize: 17,
      fcbaccaratbetLimitMinFontSize: 16,
      fcbaccaratbetLimitMaxFontSize: 16,
      fcbaccaratbetLimitMinFontFamily: 'MyriadPro-Bold', // Serpentine Bold
      fcbaccaratbetLimitMaxFontFamily: 'MyriadPro-Bold', // Serpentine Bold
      fc21betLimitMinFontSize: 17,
      fc21betLimitMinFontSizePortrait: 17,
      fc21betLimitMaxFontSize: 17,
      fc21betLimitMaxFontSizePortrait: 17,
      fc21betLimitMinFontFamily: 'MyriadPro-Bold', // Serpentine Bold
      fc21betLimitMaxFontFamily: 'MyriadPro-Bold', // Serpentine Bold
      fc21paysTextFontFamily: 'DejaVuSans-Bold', // Serpentine Bold
      fc21UserNameDesktopFontSize: '.5',
      fc21UserNamemobileFontSize: '.5',
      fcbTrendTotalValueTextFontFamily: 'MyriadPro-BoldCond', // Serpentine Bold
      fc21placeBetsFontSize: 17,
      fc21placeBetsFontFamily: 'MyriadPro-Cond',
      paysContentFontSize: 14,
      percentageContentFontSize: 15,
      paysContentTop: 4,
      percentageContentTop: 23,
      menuFontFamily: 'Verdana-Bold',
      TN_pays_blank_position_16_Top: 462,
      TN_pays_blank_position_17_Top: 462,
      TN_pays_blank_position_16_Left: 77,
      TN_pays_blank_position_17_Left: 77,

      splitCard_13_top: 294,
      landscapeSplitCard_13_top: 294,
      landscapeTnimage_split_height: 572,
      tnimage_split_height: 572,
    };
  }

  public static get sv(): translateFontProp {
    return {
      fc21PortraitgameOverTextFontsize: 22,
      fcbfooterBetFontSize: 33,
      fcbhintTextFontSize: 22,
      fcbhintQuestionMarkNumberFontSize: 22,
      fcbspreadhintTextFontSize: 21,
      fcbfooterPaidFontSize: 33,
      fcbfooterCreditFontSize: 33,
      fcbTrendTextFontSize: 26,
      fcbTrendTextNameFontSize: 26,
      fcbTrendTextValueFontSize: 69,
      fcbTrendFooterValueFontSize: 21,
      fcbTrendHeaderFontSize: 24,
      fcbTrendShuffleTextFontSize: 24,
      fcbTrendTotalValueTextFontSize: 40,
      fcbTrendFooterValueKeyFontSize: 20,
      fcbTrendTextFontFamily: 'MyriadPro-BoldCond',
      footerBetFontFamily: 'MyriadPro-Cond',
      keyBoardTextFamily: 'MyriadPro-Cond',
      alertTextFontFamily: 'MyriadPro-Cond',
      footerPaidFontFamily: 'MyriadPro-Cond',
      footerCreditFontFamily: 'MyriadPro-Cond',
      fc21footerBetFontSize: 21,
      fc21footerPaidFontSize: 21,
      fc21footerCreditFontSize: 21,
      fcbaccaratbetLimitMinFontSize: 19,
      fcbaccaratbetLimitMaxFontSize: 19,
      fcbaccaratbetLimitMinFontFamily: 'MyriadPro-Bold',
      fcbaccaratbetLimitMaxFontFamily: 'MyriadPro-Bold',
      fc21betLimitMinFontSize: 17,
      fc21betLimitMinFontSizePortrait: 17,
      fc21betLimitMaxFontSize: 17,
      fc21betLimitMaxFontSizePortrait: 17,
      fc21betLimitMinFontFamily: 'MyriadPro-Bold',
      fc21betLimitMaxFontFamily: 'MyriadPro-Bold',
      fc21paysTextFontFamily: 'SerpentineBold',
      fc21UserNameDesktopFontSize: '.4',
      fc21UserNamemobileFontSize: '.4',
      fcbTrendTotalValueTextFontFamily: 'MyriadPro-BoldCond',
      fc21placeBetsFontSize: 22,
      fc21placeBetsFontFamily: 'MyriadPro-Cond',
      paysContentFontSize: 15,
      percentageContentFontSize: 15,
      paysContentTop: 5,
      percentageContentTop: 20,
      menuFontFamily: 'Verdana-Bold',
      TN_pays_blank_position_16_Top: 440,
      TN_pays_blank_position_17_Top: 440,
      TN_pays_blank_position_16_Left: 101,
      TN_pays_blank_position_17_Left: 101,

      splitCard_13_top: 294,
      landscapeSplitCard_13_top: 294,
      landscapeTnimage_split_height: 572,
      tnimage_split_height: 572,
    };
  }

  public static get th(): translateFontProp {
    return {
      fc21PortraitgameOverTextFontsize: 23,
      fcbfooterBetFontSize: 33,
      fcbhintTextFontSize: 22,
      fcbhintQuestionMarkNumberFontSize: 22,
      fcbspreadhintTextFontSize: 23,
      fcbfooterPaidFontSize: 33,
      fcbfooterCreditFontSize: 33,
      fcbTrendTextFontSize: 26,
      fcbTrendTextNameFontSize: 26,
      fcbTrendTextValueFontSize: 69,
      fcbTrendFooterValueFontSize: 21,
      fcbTrendHeaderFontSize: 30,
      fcbTrendShuffleTextFontSize: 24,
      fcbTrendTotalValueTextFontSize: 40,
      fcbTrendFooterValueKeyFontSize: 20,
      fcbTrendTextFontFamily: 'Loma',
      footerBetFontFamily: 'Loma',
      keyBoardTextFamily: 'Loma',
      alertTextFontFamily: 'Loma',
      footerPaidFontFamily: 'Loma',
      footerCreditFontFamily: 'Loma',
      fc21footerBetFontSize: 21,
      fc21footerPaidFontSize: 21,
      fc21footerCreditFontSize: 21,
      fcbaccaratbetLimitMinFontSize: 15,
      fcbaccaratbetLimitMaxFontSize: 15,
      fcbaccaratbetLimitMinFontFamily: 'LomaBold',
      fcbaccaratbetLimitMaxFontFamily: 'LomaBold',
      fc21betLimitMinFontSize: 17,
      fc21betLimitMinFontSizePortrait: 17,
      fc21betLimitMaxFontSize: 17,
      fc21betLimitMaxFontSizePortrait: 17,
      fc21betLimitMinFontFamily: 'LomaBold',
      fc21betLimitMaxFontFamily: 'LomaBold',
      fc21paysTextFontFamily: 'LomaBold',
      fc21UserNameDesktopFontSize: '.5',
      fc21UserNamemobileFontSize: '.5',
      fcbTrendTotalValueTextFontFamily: 'LomaBold',
      fc21placeBetsFontSize: 18,
      fc21placeBetsFontFamily: 'Loma',
      paysContentFontSize: 17,
      percentageContentFontSize: 17,
      paysContentTop: 3,
      percentageContentTop: 21,
      menuFontFamily: 'Verdana-Bold',
      TN_pays_blank_position_16_Top: 440,
      TN_pays_blank_position_17_Top: 440,
      TN_pays_blank_position_16_Left: 101,
      TN_pays_blank_position_17_Left: 101,

      splitCard_13_top: 294,
      landscapeSplitCard_13_top: 294,
      landscapeTnimage_split_height: 572,
      tnimage_split_height: 572,
    };
  }

  public static get tr(): translateFontProp {
    return {
      fc21PortraitgameOverTextFontsize: 24,
      fcbfooterBetFontSize: 33,
      fcbhintTextFontSize: 22,
      fcbhintQuestionMarkNumberFontSize: 22,
      fcbspreadhintTextFontSize: 23,
      fcbfooterPaidFontSize: 26,
      fcbfooterCreditFontSize: 33,
      fcbTrendTextFontSize: 26,
      fcbTrendTextNameFontSize: 26,
      fcbTrendTextValueFontSize: 69,
      fcbTrendFooterValueFontSize: 21,
      fcbTrendHeaderFontSize: 26,
      fcbTrendShuffleTextFontSize: 19,
      fcbTrendTotalValueTextFontSize: 33,
      fcbTrendFooterValueKeyFontSize: 20,
      fcbTrendTextFontFamily: 'MyriadPro-BoldCond',
      footerBetFontFamily: 'MyriadPro-Cond',
      keyBoardTextFamily: 'MyriadPro-Cond',
      alertTextFontFamily: 'MyriadPro-Cond',
      footerPaidFontFamily: 'MyriadPro-Cond',
      footerCreditFontFamily: 'MyriadPro-Cond',
      fc21footerBetFontSize: 21,
      fc21footerPaidFontSize: 21,
      fc21footerCreditFontSize: 21,
      fcbaccaratbetLimitMinFontSize: 19,
      fcbaccaratbetLimitMaxFontSize: 18,
      fcbaccaratbetLimitMinFontFamily: 'MyriadPro-Bold',
      fcbaccaratbetLimitMaxFontFamily: 'MyriadPro-Bold',
      fc21betLimitMinFontSize: 17,
      fc21betLimitMinFontSizePortrait: 17,
      fc21betLimitMaxFontSize: 17,
      fc21betLimitMaxFontSizePortrait: 17,
      fc21betLimitMinFontFamily: 'MyriadPro-Bold',
      fc21betLimitMaxFontFamily: 'MyriadPro-Bold',
      fc21paysTextFontFamily: 'SerpentineBold',
      fc21UserNameDesktopFontSize: '.4',
      fc21UserNamemobileFontSize: '.4',
      fcbTrendTotalValueTextFontFamily: 'SerpentineBold',
      fc21placeBetsFontSize: 21,
      fc21placeBetsFontFamily: 'MyriadPro-Cond',
      paysContentFontSize: 15,
      percentageContentFontSize: 16,
      paysContentTop: 5,
      percentageContentTop: 20,
      menuFontFamily: 'Verdana-Bold',
      TN_pays_blank_position_16_Top: 449,
      TN_pays_blank_position_17_Top: 449,
      TN_pays_blank_position_16_Left: 99,
      TN_pays_blank_position_17_Left: 99,

      splitCard_13_top: 294,
      landscapeSplitCard_13_top: 294,
      landscapeTnimage_split_height: 572,
      tnimage_split_height: 572,
    };
  }

  public static get vi(): translateFontProp {
    return {
      fc21PortraitgameOverTextFontsize: 22,
      fcbfooterBetFontSize: 19,
      fcbhintTextFontSize: 22,
      fcbhintQuestionMarkNumberFontSize: 22,
      fcbspreadhintTextFontSize: 24,
      fcbfooterPaidFontSize: 15,
      fcbfooterCreditFontSize: 19,
      fcbTrendTextFontSize: 26,
      fcbTrendTextNameFontSize: 26,
      fcbTrendTextValueFontSize: 69,
      fcbTrendFooterValueFontSize: 16,
      fcbTrendHeaderFontSize: 30,
      fcbTrendShuffleTextFontSize: 24,
      fcbTrendTotalValueTextFontSize: 37,
      fcbTrendFooterValueKeyFontSize: 20,
      fcbTrendTextFontFamily: 'Verdana-Bold',
      footerBetFontFamily: 'Verdana',
      keyBoardTextFamily: 'Verdana',
      alertTextFontFamily: 'Verdana',
      footerPaidFontFamily: 'Verdana',
      footerCreditFontFamily: 'Verdana',
      fc21footerBetFontSize: 21,
      fc21footerPaidFontSize: 15,
      fc21footerCreditFontSize: 16,
      fcbaccaratbetLimitMinFontSize: 11,
      fcbaccaratbetLimitMaxFontSize: 12,
      fcbaccaratbetLimitMinFontFamily: 'Verdana-Bold',
      fcbaccaratbetLimitMaxFontFamily: 'Verdana-Bold',
      fc21betLimitMinFontSize: 12,
      fc21betLimitMinFontSizePortrait: 15,
      fc21betLimitMaxFontSize: 12,
      fc21betLimitMaxFontSizePortrait: 15,
      fc21betLimitMinFontFamily: 'Verdana-Bold',
      fc21betLimitMaxFontFamily: 'Verdana-Bold',
      fc21paysTextFontFamily: 'Verdana-Bold',
      fc21UserNameDesktopFontSize: '.5',
      fc21UserNamemobileFontSize: '.5',
      fcbTrendTotalValueTextFontFamily: 'Verdana-Bold',
      fc21placeBetsFontSize: 22,
      fc21placeBetsFontFamily: 'Verdana',
      paysContentFontSize: 12,
      percentageContentFontSize: 14,
      paysContentTop: 5,
      percentageContentTop: 20,
      menuFontFamily: 'Verdana-Bold',
      TN_pays_blank_position_16_Top: 451,
      TN_pays_blank_position_17_Top: 451,
      TN_pays_blank_position_16_Left: 93,
      TN_pays_blank_position_17_Left: 93,

      splitCard_13_top: 294,
      landscapeSplitCard_13_top: 294,
      landscapeTnimage_split_height: 572,
      tnimage_split_height: 572,
    };
  }

  public static get ar(): translateFontProp {
    return {
      fc21PortraitgameOverTextFontsize: 24,
      fcbfooterBetFontSize: 33,
      fcbhintTextFontSize: 22,
      fcbhintQuestionMarkNumberFontSize: 22,
      fcbspreadhintTextFontSize: 22,
      fcbfooterPaidFontSize: 33,
      fcbfooterCreditFontSize: 33,
      fcbTrendTextFontSize: 26,
      fcbTrendTextNameFontSize: 26,
      fcbTrendTextValueFontSize: 69,
      fcbTrendFooterValueFontSize: 20,
      fcbTrendHeaderFontSize: 26,
      fcbTrendShuffleTextFontSize: 22,
      fcbTrendTotalValueTextFontSize: 33,
      fcbTrendFooterValueKeyFontSize: 20,
      fcbTrendTextFontFamily: 'MyriadPro-BoldCond',
      footerBetFontFamily: 'MyriadPro-Cond',
      keyBoardTextFamily: 'Adobe-Arabic',
      alertTextFontFamily: 'Adobe-Arabic',
      footerPaidFontFamily: 'MyriadPro-Cond',
      footerCreditFontFamily: 'MyriadPro-Cond',
      fc21footerBetFontSize: 21,
      fc21footerPaidFontSize: 21,
      fc21footerCreditFontSize: 20,
      fcbaccaratbetLimitMinFontSize: 22,
      fcbaccaratbetLimitMaxFontSize: 22,
      fcbaccaratbetLimitMinFontFamily: 'Adobe-Arabic',
      fcbaccaratbetLimitMaxFontFamily: 'Adobe-Arabic',
      fc21betLimitMinFontSize: 20,
      fc21betLimitMinFontSizePortrait: 18,
      fc21betLimitMaxFontSize: 20,
      fc21betLimitMaxFontSizePortrait: 18,
      fc21betLimitMinFontFamily: 'Adobe-Arabic',
      fc21betLimitMaxFontFamily: 'Adobe-Arabic',
      fc21paysTextFontFamily: 'ArialHebrew-Bold',
      fc21UserNameDesktopFontSize: '.45',
      fc21UserNamemobileFontSize: '.45',
      fcbTrendTotalValueTextFontFamily: 'ArialHebrew-Bold',
      fc21placeBetsFontSize: 22,
      fc21placeBetsFontFamily: 'MyriadPro-Cond',
      paysContentFontSize: 17,
      percentageContentFontSize: 17,
      paysContentTop: 6,
      percentageContentTop: 24,
      menuFontFamily: 'Adobe-Arabic',
      TN_pays_blank_position_16_Top: 490,
      TN_pays_blank_position_17_Top: 490,
      TN_pays_blank_position_16_Left: 606,
      TN_pays_blank_position_17_Left: 606,

      splitCard_13_top: 294,
      landscapeSplitCard_13_top: 294,
      landscapeTnimage_split_height: 572,
      tnimage_split_height: 572,
    };
  }

  public static get bg(): translateFontProp {
    return {
      fc21PortraitgameOverTextFontsize: 24,
      fcbfooterBetFontSize: 33,
      fcbhintTextFontSize: 17,
      fcbhintQuestionMarkNumberFontSize: 17,
      fcbspreadhintTextFontSize: 18,
      fcbfooterPaidFontSize: 33,
      fcbfooterCreditFontSize: 33,
      fcbTrendTextFontSize: 27,
      fcbTrendTextNameFontSize: 27,
      fcbTrendTextValueFontSize: 69,
      fcbTrendFooterValueFontSize: 20,
      fcbTrendHeaderFontSize: 30,
      fcbTrendShuffleTextFontSize: 22,
      fcbTrendTotalValueTextFontSize: 40,
      fcbTrendFooterValueKeyFontSize: 20,
      fcbTrendTextFontFamily: 'MyriadPro-BoldCond',
      footerBetFontFamily: 'MyriadPro-Cond',
      keyBoardTextFamily: 'MyriadPro-Cond',
      alertTextFontFamily: 'MyriadPro-Cond',
      footerPaidFontFamily: 'MyriadPro-Cond',
      footerCreditFontFamily: 'MyriadPro-Cond',
      fc21footerBetFontSize: 21,
      fc21footerPaidFontSize: 21,
      fc21footerCreditFontSize: 20,
      fcbaccaratbetLimitMinFontSize: 23,
      fcbaccaratbetLimitMaxFontSize: 23,
      fcbaccaratbetLimitMinFontFamily: 'MyriadPro-Bold',
      fcbaccaratbetLimitMaxFontFamily: 'MyriadPro-Bold',
      fc21betLimitMinFontSize: 18,
      fc21betLimitMinFontSizePortrait: 18,
      fc21betLimitMaxFontSize: 18,
      fc21betLimitMaxFontSizePortrait: 18,
      fc21betLimitMinFontFamily: 'MyriadPro-Bold',
      fc21betLimitMaxFontFamily: 'MyriadPro-Bold',
      fc21paysTextFontFamily: 'MyriadPro-Bold',
      fc21UserNameDesktopFontSize: '.5',
      fc21UserNamemobileFontSize: '.5',
      fcbTrendTotalValueTextFontFamily: 'MyriadPro-BoldCond',
      fc21placeBetsFontSize: 22,
      fc21placeBetsFontFamily: 'MyriadPro-Cond',
      paysContentFontSize: 13,
      percentageContentFontSize: 14,
      paysContentTop: 5,
      percentageContentTop: 20,
      menuFontFamily: 'Verdana-Bold',
      TN_pays_blank_position_16_Top: 458,
      TN_pays_blank_position_17_Top: 458,
      TN_pays_blank_position_16_Left: 85,
      TN_pays_blank_position_17_Left: 85,

      splitCard_13_top: 294,
      landscapeSplitCard_13_top: 294,
      landscapeTnimage_split_height: 572,
      tnimage_split_height: 572,
    };
  }

  public static get ee(): translateFontProp {
    return {
      fc21PortraitgameOverTextFontsize: 24,
      fcbfooterBetFontSize: 33,
      fcbhintTextFontSize: 20,
      fcbhintQuestionMarkNumberFontSize: 20,
      fcbspreadhintTextFontSize: 20,
      fcbfooterPaidFontSize: 33,
      fcbfooterCreditFontSize: 33,
      fcbTrendTextFontSize: 26,
      fcbTrendTextNameFontSize: 26,
      fcbTrendTextValueFontSize: 69,
      fcbTrendFooterValueFontSize: 20,
      fcbTrendHeaderFontSize: 25,
      fcbTrendShuffleTextFontSize: 25,
      fcbTrendTotalValueTextFontSize: 40,
      fcbTrendFooterValueKeyFontSize: 20,
      fcbTrendTextFontFamily: 'Verdana-Bold',
      footerBetFontFamily: 'MyriadPro-Cond',
      keyBoardTextFamily: 'MyriadPro-Cond',
      alertTextFontFamily: 'MyriadPro-Cond',
      footerPaidFontFamily: 'MyriadPro-Cond',
      footerCreditFontFamily: 'MyriadPro-Cond',
      fc21footerBetFontSize: 21,
      fc21footerPaidFontSize: 21,
      fc21footerCreditFontSize: 20,
      fcbaccaratbetLimitMinFontSize: 21,
      fcbaccaratbetLimitMaxFontSize: 20,
      fcbaccaratbetLimitMinFontFamily: 'MyriadPro-Bold',
      fcbaccaratbetLimitMaxFontFamily: 'MyriadPro-Bold',
      fc21betLimitMinFontSize: 17,
      fc21betLimitMinFontSizePortrait: 17,
      fc21betLimitMaxFontSize: 17,
      fc21betLimitMaxFontSizePortrait: 17,
      fc21betLimitMinFontFamily: 'MyriadPro-Bold',
      fc21betLimitMaxFontFamily: 'MyriadPro-Bold',
      fc21paysTextFontFamily: 'Verdana-Bold',
      fc21UserNameDesktopFontSize: '.5',
      fc21UserNamemobileFontSize: '.5',
      fcbTrendTotalValueTextFontFamily: 'MyriadPro-BoldCond',
      fc21placeBetsFontSize: 22,
      fc21placeBetsFontFamily: 'MyriadPro-Cond',
      paysContentFontSize: 14,
      percentageContentFontSize: 14,
      paysContentTop: 5,
      percentageContentTop: 20,
      menuFontFamily: 'Verdana-Bold',
      TN_pays_blank_position_16_Top: 488,
      TN_pays_blank_position_17_Top: 488,
      TN_pays_blank_position_16_Left: 77,
      TN_pays_blank_position_17_Left: 77,

      splitCard_13_top: 294,
      landscapeSplitCard_13_top: 294,
      landscapeTnimage_split_height: 572,
      tnimage_split_height: 572,
    };
  }

  public static get ge(): translateFontProp {
    return {
      fc21PortraitgameOverTextFontsize: 19,
      fcbfooterBetFontSize: 33,
      fcbhintTextFontSize: 22,
      fcbhintQuestionMarkNumberFontSize: 22,
      fcbspreadhintTextFontSize: 19,
      fcbfooterPaidFontSize: 33,
      fcbfooterCreditFontSize: 33,
      fcbTrendTextFontSize: 26,
      fcbTrendTextNameFontSize: 26,
      fcbTrendTextValueFontSize: 69,
      fcbTrendFooterValueFontSize: 20,
      fcbTrendHeaderFontSize: 19,
      fcbTrendShuffleTextFontSize: 22,
      fcbTrendTotalValueTextFontSize: 30,
      fcbTrendFooterValueKeyFontSize: 20,
      fcbTrendTextFontFamily: 'DejaVuSans-Bold',
      footerBetFontFamily: 'MyriadPro-Cond',
      keyBoardTextFamily: 'MyriadPro-Cond',
      alertTextFontFamily: 'MyriadPro-Cond',
      footerPaidFontFamily: 'MyriadPro-Cond',
      footerCreditFontFamily: 'MyriadPro-Cond',
      fc21footerBetFontSize: 21,
      fc21footerPaidFontSize: 21,
      fc21footerCreditFontSize: 20,
      fcbaccaratbetLimitMinFontSize: 21,
      fcbaccaratbetLimitMaxFontSize: 19,
      fcbaccaratbetLimitMinFontFamily: 'Kelvinch', // Kelvinch Bold
      fcbaccaratbetLimitMaxFontFamily: 'Kelvinch', //Kelvinch Bold
      fc21betLimitMinFontSize: 17,
      fc21betLimitMinFontSizePortrait: 17,
      fc21betLimitMaxFontSize: 17,
      fc21betLimitMaxFontSizePortrait: 17,
      fc21betLimitMinFontFamily: 'Kelvinch', // Kelvinch Bold
      fc21betLimitMaxFontFamily: 'Kelvinch', // Kelvinch Bold
      fc21paysTextFontFamily: 'DejaVuSans-Bold', // Kelvinch Bold
      fc21UserNameDesktopFontSize: '.5',
      fc21UserNamemobileFontSize: '.5',
      fcbTrendTotalValueTextFontFamily: 'DejaVuSans-Bold', // Kelvinch Bold
      fc21placeBetsFontSize: 22,
      fc21placeBetsFontFamily: 'MyriadPro-Cond',
      paysContentFontSize: 12,
      percentageContentFontSize: 15,
      paysContentTop: 5,
      percentageContentTop: 20,
      menuFontFamily: 'Verdana-Bold',
      TN_pays_blank_position_16_Top: 451,
      TN_pays_blank_position_17_Top: 448,
      TN_pays_blank_position_16_Left: 92,
      TN_pays_blank_position_17_Left: 92,

      splitCard_13_top: 294,
      landscapeSplitCard_13_top: 294,
      landscapeTnimage_split_height: 572,
      tnimage_split_height: 572,
    };
  }

  public static get gr(): translateFontProp {
    return {
      fc21PortraitgameOverTextFontsize: 24,
      fcbfooterBetFontSize: 33,
      fcbhintTextFontSize: 22,
      fcbhintQuestionMarkNumberFontSize: 22,
      fcbspreadhintTextFontSize: 22,
      fcbfooterPaidFontSize: 33,
      fcbfooterCreditFontSize: 33,
      fcbTrendTextFontSize: 26,
      fcbTrendTextNameFontSize: 26,
      fcbTrendTextValueFontSize: 69,
      fcbTrendFooterValueFontSize: 20,
      fcbTrendHeaderFontSize: 28,
      fcbTrendShuffleTextFontSize: 24,
      fcbTrendTotalValueTextFontSize: 37,
      fcbTrendFooterValueKeyFontSize: 20,
      fcbTrendTextFontFamily: 'MyriadPro-BoldCond',
      footerBetFontFamily: 'MyriadPro-Cond',
      keyBoardTextFamily: 'MyriadPro-Cond',
      alertTextFontFamily: 'MyriadPro-Cond',
      footerPaidFontFamily: 'MyriadPro-Cond',
      footerCreditFontFamily: 'MyriadPro-Cond',
      fc21footerBetFontSize: 21,
      fc21footerPaidFontSize: 21,
      fc21footerCreditFontSize: 20,
      fcbaccaratbetLimitMinFontSize: 23,
      fcbaccaratbetLimitMaxFontSize: 23,
      fcbaccaratbetLimitMinFontFamily: 'MyriadPro-Bold',
      fcbaccaratbetLimitMaxFontFamily: 'MyriadPro-Bold',
      fc21betLimitMinFontSize: 17,
      fc21betLimitMinFontSizePortrait: 17,
      fc21betLimitMaxFontSize: 17,
      fc21betLimitMaxFontSizePortrait: 17,
      fc21betLimitMinFontFamily: 'MyriadPro-Bold',
      fc21betLimitMaxFontFamily: 'MyriadPro-Bold',
      fc21paysTextFontFamily: 'MyriadPro-BoldCond',
      fc21UserNameDesktopFontSize: '.5',
      fc21UserNamemobileFontSize: '.5',
      fcbTrendTotalValueTextFontFamily: 'MyriadPro-BoldCond',
      fc21placeBetsFontSize: 22,
      fc21placeBetsFontFamily: 'MyriadPro-Cond',
      paysContentFontSize: 15,
      percentageContentFontSize: 15,
      paysContentTop: 5,
      percentageContentTop: 20,
      menuFontFamily: 'Verdana-Bold',
      TN_pays_blank_position_16_Top: 458,
      TN_pays_blank_position_17_Top: 458,
      TN_pays_blank_position_16_Left: 80,
      TN_pays_blank_position_17_Left: 80,

      splitCard_13_top: 303,
      landscapeSplitCard_13_top: 303,
      landscapeTnimage_split_height: 610,
      tnimage_split_height: 610,
    };
  }

  public static get 'hi-IN'(): translateFontProp {
    return {
      fc21PortraitgameOverTextFontsize: 24,
      fcbfooterBetFontSize: 33,
      fcbhintTextFontSize: 23,
      fcbhintQuestionMarkNumberFontSize: 22,
      fcbspreadhintTextFontSize: 22,
      fcbfooterPaidFontSize: 33,
      fcbfooterCreditFontSize: 33,
      fcbTrendTextFontSize: 27,
      fcbTrendTextNameFontSize: 27,
      fcbTrendTextValueFontSize: 69,
      fcbTrendFooterValueFontSize: 20,
      fcbTrendHeaderFontSize: 42,
      fcbTrendShuffleTextFontSize: 41,
      fcbTrendTotalValueTextFontSize: 39,
      fcbTrendFooterValueKeyFontSize: 20,
      fcbTrendTextFontFamily: 'Adobe Devanagari',
      footerBetFontFamily: 'MyriadPro-Cond',
      keyBoardTextFamily: 'MyriadPro-Cond',
      alertTextFontFamily: 'MyriadPro-Cond',
      footerPaidFontFamily: 'MyriadPro-Cond',
      footerCreditFontFamily: 'MyriadPro-Cond',
      fc21footerBetFontSize: 21,
      fc21footerPaidFontSize: 21,
      fc21footerCreditFontSize: 20,
      fcbaccaratbetLimitMinFontSize: 23,
      fcbaccaratbetLimitMaxFontSize: 23,
      fcbaccaratbetLimitMinFontFamily: 'Adobe Devanagari',
      fcbaccaratbetLimitMaxFontFamily: 'Adobe Devanagari',
      fc21betLimitMinFontSize: 17,
      fc21betLimitMinFontSizePortrait: 17,
      fc21betLimitMaxFontSize: 17,
      fc21betLimitMaxFontSizePortrait: 17,
      fc21betLimitMinFontFamily: 'Adobe Devanagari',
      fc21betLimitMaxFontFamily: 'Adobe Devanagari',
      fc21paysTextFontFamily: 'Adobe Devanagari',
      fc21UserNameDesktopFontSize: '.5',
      fc21UserNamemobileFontSize: '.5',
      fcbTrendTotalValueTextFontFamily: 'Adobe Devanagari',
      fc21placeBetsFontSize: 22,
      fc21placeBetsFontFamily: 'MyriadPro-Cond',
      paysContentFontSize: 13,
      percentageContentFontSize: 15,
      paysContentTop: 5,
      percentageContentTop: 21,
      menuFontFamily: 'Verdana-Bold',
      TN_pays_blank_position_16_Top: 444,
      TN_pays_blank_position_17_Top: 444,
      TN_pays_blank_position_16_Left: 74,
      TN_pays_blank_position_17_Left: 74,

      splitCard_13_top: 294,
      landscapeSplitCard_13_top: 294,
      landscapeTnimage_split_height: 572,
      tnimage_split_height: 572,
    };
  }

  public static get hu(): translateFontProp {
    return {
      fc21PortraitgameOverTextFontsize: 24,
      fcbfooterBetFontSize: 33,
      fcbhintTextFontSize: 18,
      fcbhintQuestionMarkNumberFontSize: 18,
      fcbspreadhintTextFontSize: 20,
      fcbfooterPaidFontSize: 33,
      fcbfooterCreditFontSize: 33,
      fcbTrendTextFontSize: 30,
      fcbTrendTextNameFontSize: 30,
      fcbTrendTextValueFontSize: 69,
      fcbTrendFooterValueFontSize: 20,
      fcbTrendHeaderFontSize: 34,
      fcbTrendShuffleTextFontSize: 30,
      fcbTrendTotalValueTextFontSize: 40,
      fcbTrendFooterValueKeyFontSize: 20,
      fcbTrendTextFontFamily: 'MyriadPro-BoldCond',
      footerBetFontFamily: 'MyriadPro-Cond',
      keyBoardTextFamily: 'MyriadPro-Cond',
      alertTextFontFamily: 'MyriadPro-Cond',
      footerPaidFontFamily: 'MyriadPro-Cond',
      footerCreditFontFamily: 'MyriadPro-Cond',
      fc21footerBetFontSize: 21,
      fc21footerPaidFontSize: 21,
      fc21footerCreditFontSize: 20,
      fcbaccaratbetLimitMinFontSize: 23,
      fcbaccaratbetLimitMaxFontSize: 23,
      fcbaccaratbetLimitMinFontFamily: 'MyriadPro-Bold',
      fcbaccaratbetLimitMaxFontFamily: 'MyriadPro-Bold',
      fc21betLimitMinFontSize: 17,
      fc21betLimitMinFontSizePortrait: 17,
      fc21betLimitMaxFontSize: 17,
      fc21betLimitMaxFontSizePortrait: 17,
      fc21betLimitMinFontFamily: 'MyriadPro-Bold',
      fc21betLimitMaxFontFamily: 'MyriadPro-Bold',
      fc21paysTextFontFamily: 'SerpentineBold',
      fc21UserNameDesktopFontSize: '.4',
      fc21UserNamemobileFontSize: '.4',
      fcbTrendTotalValueTextFontFamily: 'MyriadPro-BoldCond',
      fc21placeBetsFontSize: 22,
      fc21placeBetsFontFamily: 'MyriadPro-Cond',
      paysContentFontSize: 12,
      percentageContentFontSize: 14,
      paysContentTop: 5,
      percentageContentTop: 20,
      menuFontFamily: 'Verdana-Bold',
      TN_pays_blank_position_16_Top: 440,
      TN_pays_blank_position_17_Top: 440,
      TN_pays_blank_position_16_Left: 101,
      TN_pays_blank_position_17_Left: 101,

      splitCard_13_top: 294,
      landscapeSplitCard_13_top: 294,
      landscapeTnimage_split_height: 572,
      tnimage_split_height: 572,
    };
  }

  public static get lt(): translateFontProp {
    return {
      fc21PortraitgameOverTextFontsize: 24,
      fcbfooterBetFontSize: 33,
      fcbhintTextFontSize: 22,
      fcbhintQuestionMarkNumberFontSize: 22,
      fcbspreadhintTextFontSize: 22,
      fcbfooterPaidFontSize: 33,
      fcbfooterCreditFontSize: 33,
      fcbTrendTextFontSize: 26,
      fcbTrendTextNameFontSize: 27,
      fcbTrendTextValueFontSize: 67,
      fcbTrendFooterValueFontSize: 20,
      fcbTrendHeaderFontSize: 25,
      fcbTrendShuffleTextFontSize: 30,
      fcbTrendTotalValueTextFontSize: 40,
      fcbTrendFooterValueKeyFontSize: 20,
      fcbTrendTextFontFamily: 'MyriadPro-BoldCond',
      footerBetFontFamily: 'MyriadPro-Cond',
      keyBoardTextFamily: 'MyriadPro-Cond',
      alertTextFontFamily: 'MyriadPro-Cond',
      footerPaidFontFamily: 'MyriadPro-Cond',
      footerCreditFontFamily: 'MyriadPro-Cond',
      fc21footerBetFontSize: 21,
      fc21footerPaidFontSize: 21,
      fc21footerCreditFontSize: 20,
      fcbaccaratbetLimitMinFontSize: 23,
      fcbaccaratbetLimitMaxFontSize: 23,
      fcbaccaratbetLimitMinFontFamily: 'MyriadPro-Bold',
      fcbaccaratbetLimitMaxFontFamily: 'MyriadPro-Bold',
      fc21betLimitMinFontSize: 17,
      fc21betLimitMinFontSizePortrait: 17,
      fc21betLimitMaxFontSize: 17,
      fc21betLimitMaxFontSizePortrait: 17,
      fc21betLimitMinFontFamily: 'MyriadPro-Bold',
      fc21betLimitMaxFontFamily: 'MyriadPro-Bold',
      fc21paysTextFontFamily: 'MyriadPro-BoldCond',
      fc21UserNameDesktopFontSize: '.5',
      fc21UserNamemobileFontSize: '.5',
      fcbTrendTotalValueTextFontFamily: 'MyriadPro-BoldCond',
      fc21placeBetsFontSize: 22,
      fc21placeBetsFontFamily: 'MyriadPro-Cond',
      paysContentFontSize: 15,
      percentageContentFontSize: 15,
      paysContentTop: 5,
      percentageContentTop: 20,
      menuFontFamily: 'Verdana-Bold',
      TN_pays_blank_position_16_Top: 461,
      TN_pays_blank_position_17_Top: 461,
      TN_pays_blank_position_16_Left: 73,
      TN_pays_blank_position_17_Left: 73,

      splitCard_13_top: 294,
      landscapeSplitCard_13_top: 294,
      landscapeTnimage_split_height: 572,
      tnimage_split_height: 572,
    };
  }

  public static get kh(): translateFontProp {
    return {
      fc21PortraitgameOverTextFontsize: 24,
      fcbfooterBetFontSize: 33,
      fcbhintTextFontSize: 22,
      fcbhintQuestionMarkNumberFontSize: 22,
      fcbspreadhintTextFontSize: 17,
      fcbfooterPaidFontSize: 33,
      fcbfooterCreditFontSize: 33,
      fcbTrendTextFontSize: 27,
      fcbTrendTextNameFontSize: 27,
      fcbTrendTextValueFontSize: 69,
      fcbTrendFooterValueFontSize: 20,
      fcbTrendHeaderFontSize: 30,
      fcbTrendShuffleTextFontSize: 30,
      fcbTrendTotalValueTextFontSize: 30,
      fcbTrendFooterValueKeyFontSize: 20,
      fcbTrendTextFontFamily: 'Khmer',
      footerBetFontFamily: 'MyriadPro-Cond',
      keyBoardTextFamily: 'MyriadPro-Cond',
      alertTextFontFamily: 'MyriadPro-Cond',
      footerPaidFontFamily: 'MyriadPro-Cond',
      footerCreditFontFamily: 'MyriadPro-Cond',
      fc21footerBetFontSize: 21,
      fc21footerPaidFontSize: 21,
      fc21footerCreditFontSize: 20,
      fcbaccaratbetLimitMinFontSize: 20,
      fcbaccaratbetLimitMaxFontSize: 20,
      fcbaccaratbetLimitMinFontFamily: 'Chantrea-UI',
      fcbaccaratbetLimitMaxFontFamily: 'Chantrea-UI',
      fc21betLimitMinFontSize: 16,
      fc21betLimitMinFontSizePortrait: 17,
      fc21betLimitMaxFontSize: 16,
      fc21betLimitMaxFontSizePortrait: 17,
      fc21betLimitMinFontFamily: 'Chantrea-UI',
      fc21betLimitMaxFontFamily: 'Chantrea-UI',
      fc21paysTextFontFamily: 'Khmer',
      fc21UserNameDesktopFontSize: '.5',
      fc21UserNamemobileFontSize: '.5',
      fcbTrendTotalValueTextFontFamily: 'Khmer',
      fc21placeBetsFontSize: 22,
      fc21placeBetsFontFamily: 'MyriadPro-Cond',
      paysContentFontSize: 12,
      percentageContentFontSize: 15,
      paysContentTop: 5,
      percentageContentTop: 22,
      menuFontFamily: 'Verdana-Bold',
      TN_pays_blank_position_16_Top: 440,
      TN_pays_blank_position_17_Top: 440,
      TN_pays_blank_position_16_Left: 101,
      TN_pays_blank_position_17_Left: 101,

      splitCard_13_top: 294,
      landscapeSplitCard_13_top: 294,
      landscapeTnimage_split_height: 572,
      tnimage_split_height: 572,
    };
  }

  public static get lv(): translateFontProp {
    return {
      fc21PortraitgameOverTextFontsize: 24,
      fcbfooterBetFontSize: 33,
      fcbhintTextFontSize: 22,
      fcbhintQuestionMarkNumberFontSize: 22,
      fcbspreadhintTextFontSize: 22,
      fcbfooterPaidFontSize: 33,
      fcbfooterCreditFontSize: 33,
      fcbTrendTextFontSize: 28,
      fcbTrendTextNameFontSize: 28,
      fcbTrendTextValueFontSize: 69,
      fcbTrendFooterValueFontSize: 20,
      fcbTrendHeaderFontSize: 30,
      fcbTrendShuffleTextFontSize: 17,
      fcbTrendTotalValueTextFontSize: 40,
      fcbTrendFooterValueKeyFontSize: 20,
      fcbTrendTextFontFamily: 'MyriadPro-BoldCond',
      footerBetFontFamily: 'MyriadPro-Cond',
      keyBoardTextFamily: 'MyriadPro-Cond',
      alertTextFontFamily: 'MyriadPro-Cond',
      footerPaidFontFamily: 'MyriadPro-Cond',
      footerCreditFontFamily: 'MyriadPro-Cond',
      fc21footerBetFontSize: 21,
      fc21footerPaidFontSize: 21,
      fc21footerCreditFontSize: 20,
      fcbaccaratbetLimitMinFontSize: 23,
      fcbaccaratbetLimitMaxFontSize: 23,
      fcbaccaratbetLimitMinFontFamily: 'MyriadPro-Bold',
      fcbaccaratbetLimitMaxFontFamily: 'MyriadPro-Bold',
      fc21betLimitMinFontSize: 17,
      fc21betLimitMinFontSizePortrait: 17,
      fc21betLimitMaxFontSize: 17,
      fc21betLimitMaxFontSizePortrait: 17,
      fc21betLimitMinFontFamily: 'MyriadPro-Bold',
      fc21betLimitMaxFontFamily: 'MyriadPro-Bold',
      fc21paysTextFontFamily: 'MyriadPro-BoldCond',
      fc21UserNameDesktopFontSize: '.5',
      fc21UserNamemobileFontSize: '.5',
      fcbTrendTotalValueTextFontFamily: 'MyriadPro-BoldCond',
      fc21placeBetsFontSize: 22,
      fc21placeBetsFontFamily: 'MyriadPro-Cond',
      paysContentFontSize: 16,
      percentageContentFontSize: 16,
      paysContentTop: 5,
      percentageContentTop: 20,
      menuFontFamily: 'Verdana-Bold',
      TN_pays_blank_position_16_Top: 463,
      TN_pays_blank_position_17_Top: 463,
      TN_pays_blank_position_16_Left: 82,
      TN_pays_blank_position_17_Left: 82,

      splitCard_13_top: 294,
      landscapeSplitCard_13_top: 294,
      landscapeTnimage_split_height: 572,
      tnimage_split_height: 572,
    };
  }

  public static get mt(): translateFontProp {
    return {
      fc21PortraitgameOverTextFontsize: 20,
      fcbfooterBetFontSize: 33,
      fcbhintTextFontSize: 22,
      fcbhintQuestionMarkNumberFontSize: 22,
      fcbspreadhintTextFontSize: 21,
      fcbfooterPaidFontSize: 33,
      fcbfooterCreditFontSize: 33,
      fcbTrendTextFontSize: 28,
      fcbTrendTextNameFontSize: 28,
      fcbTrendTextValueFontSize: 69,
      fcbTrendFooterValueFontSize: 20,
      fcbTrendHeaderFontSize: 30,
      fcbTrendShuffleTextFontSize: 24,
      fcbTrendTotalValueTextFontSize: 40,
      fcbTrendFooterValueKeyFontSize: 20,
      fcbTrendTextFontFamily: 'MyriadPro-BoldCond',
      footerBetFontFamily: 'MyriadPro-Cond',
      keyBoardTextFamily: 'MyriadPro-Cond',
      alertTextFontFamily: 'MyriadPro-Cond',
      footerPaidFontFamily: 'MyriadPro-Cond',
      footerCreditFontFamily: 'MyriadPro-Cond',
      fc21footerBetFontSize: 21,
      fc21footerPaidFontSize: 21,
      fc21footerCreditFontSize: 20,
      fcbaccaratbetLimitMinFontSize: 23,
      fcbaccaratbetLimitMaxFontSize: 23,
      fcbaccaratbetLimitMinFontFamily: 'MyriadPro-Bold',
      fcbaccaratbetLimitMaxFontFamily: 'MyriadPro-Bold',
      fc21betLimitMinFontSize: 17,
      fc21betLimitMinFontSizePortrait: 17,
      fc21betLimitMaxFontSize: 17,
      fc21betLimitMaxFontSizePortrait: 17,
      fc21betLimitMinFontFamily: 'MyriadPro-Bold',
      fc21betLimitMaxFontFamily: 'MyriadPro-Bold',
      fc21paysTextFontFamily: 'MyriadPro-BoldCond',
      fc21UserNameDesktopFontSize: '.5',
      fc21UserNamemobileFontSize: '.5',
      fcbTrendTotalValueTextFontFamily: 'MyriadPro-BoldCond',
      fc21placeBetsFontSize: 22,
      fc21placeBetsFontFamily: 'MyriadPro-Cond',
      paysContentFontSize: 17,
      percentageContentFontSize: 17,
      paysContentTop: 4,
      percentageContentTop: 20,
      menuFontFamily: 'Verdana-Bold',
      TN_pays_blank_position_16_Top: 460,
      TN_pays_blank_position_17_Top: 460,
      TN_pays_blank_position_16_Left: 73,
      TN_pays_blank_position_17_Left: 73,

      splitCard_13_top: 294,
      landscapeSplitCard_13_top: 294,
      landscapeTnimage_split_height: 572,
      tnimage_split_height: 572,
    };
  }

  public static get my(): translateFontProp {
    return {
      fc21PortraitgameOverTextFontsize: 24,
      fcbfooterBetFontSize: 33,
      fcbhintTextFontSize: 22,
      fcbhintQuestionMarkNumberFontSize: 22,
      fcbspreadhintTextFontSize: 21,
      fcbfooterPaidFontSize: 33,
      fcbfooterCreditFontSize: 33,
      fcbTrendTextFontSize: 26,
      fcbTrendTextNameFontSize: 26,
      fcbTrendTextValueFontSize: 69,
      fcbTrendFooterValueFontSize: 20,
      fcbTrendHeaderFontSize: 29,
      fcbTrendShuffleTextFontSize: 32,
      fcbTrendTotalValueTextFontSize: 40,
      fcbTrendFooterValueKeyFontSize: 20,
      fcbTrendTextFontFamily: 'MyriadPro-BoldCond',
      footerBetFontFamily: 'MyriadPro-Cond',
      keyBoardTextFamily: 'MyriadPro-Cond',
      alertTextFontFamily: 'MyriadPro-Cond',
      footerPaidFontFamily: 'MyriadPro-Cond',
      footerCreditFontFamily: 'MyriadPro-Cond',
      fc21footerBetFontSize: 21,
      fc21footerPaidFontSize: 21,
      fc21footerCreditFontSize: 20,
      fcbaccaratbetLimitMinFontSize: 23,
      fcbaccaratbetLimitMaxFontSize: 20,
      fcbaccaratbetLimitMinFontFamily: 'MyriadPro-BoldCond',
      fcbaccaratbetLimitMaxFontFamily: 'MyriadPro-BoldCond',
      fc21betLimitMinFontSize: 17,
      fc21betLimitMinFontSizePortrait: 17,
      fc21betLimitMaxFontSize: 17,
      fc21betLimitMaxFontSizePortrait: 17,
      fc21betLimitMinFontFamily: 'MyriadPro-BoldCond',
      fc21betLimitMaxFontFamily: 'MyriadPro-BoldCond',
      fc21paysTextFontFamily: 'MyriadPro-Bold',
      fc21UserNameDesktopFontSize: '.5',
      fc21UserNamemobileFontSize: '.5',
      fcbTrendTotalValueTextFontFamily: 'MyriadPro-BoldCond',
      fc21placeBetsFontSize: 22,
      fc21placeBetsFontFamily: 'MyriadPro-Cond',
      paysContentFontSize: 15,
      percentageContentFontSize: 15,
      paysContentTop: 5,
      percentageContentTop: 20,
      menuFontFamily: 'Verdana-Bold',
      TN_pays_blank_position_16_Top: 458,
      TN_pays_blank_position_17_Top: 458,
      TN_pays_blank_position_16_Left: 85,
      TN_pays_blank_position_17_Left: 85,

      splitCard_13_top: 294,
      landscapeSplitCard_13_top: 294,
      landscapeTnimage_split_height: 572,
      tnimage_split_height: 572,
    };
  }

  public static get ph(): translateFontProp {
    return {
      fc21PortraitgameOverTextFontsize: 22,
      fcbfooterBetFontSize: 33,
      fcbhintTextFontSize: 18,
      fcbhintQuestionMarkNumberFontSize: 19,
      fcbspreadhintTextFontSize: 17,
      fcbfooterPaidFontSize: 33,
      fcbfooterCreditFontSize: 33,
      fcbTrendTextFontSize: 25,
      fcbTrendTextNameFontSize: 25,
      fcbTrendTextValueFontSize: 69,
      fcbTrendFooterValueFontSize: 20,
      fcbTrendHeaderFontSize: 25,
      fcbTrendShuffleTextFontSize: 25,
      fcbTrendTotalValueTextFontSize: 33,
      fcbTrendFooterValueKeyFontSize: 20,
      fcbTrendTextFontFamily: 'MyriadPro-BoldCond',
      footerBetFontFamily: 'MyriadPro-Cond',
      keyBoardTextFamily: 'MyriadPro-Cond',
      alertTextFontFamily: 'MyriadPro-Cond',
      footerPaidFontFamily: 'MyriadPro-Cond',
      footerCreditFontFamily: 'MyriadPro-Cond',
      fc21footerBetFontSize: 21,
      fc21footerPaidFontSize: 21,
      fc21footerCreditFontSize: 20,
      fcbaccaratbetLimitMinFontSize: 23,
      fcbaccaratbetLimitMaxFontSize: 23,
      fcbaccaratbetLimitMinFontFamily: 'MyriadPro-Bold',
      fcbaccaratbetLimitMaxFontFamily: 'MyriadPro-Bold',
      fc21betLimitMinFontSize: 17,
      fc21betLimitMinFontSizePortrait: 17,
      fc21betLimitMaxFontSize: 17,
      fc21betLimitMaxFontSizePortrait: 17,
      fc21betLimitMinFontFamily: 'MyriadPro-Bold',
      fc21betLimitMaxFontFamily: 'MyriadPro-Bold',
      fc21paysTextFontFamily: 'SerpentineBold',
      fc21UserNameDesktopFontSize: '.4',
      fc21UserNamemobileFontSize: '.4',
      fcbTrendTotalValueTextFontFamily: 'MyriadPro-BoldCond',
      fc21placeBetsFontSize: 22,
      fc21placeBetsFontFamily: 'MyriadPro-Cond',
      paysContentFontSize: 11,
      percentageContentFontSize: 15,
      paysContentTop: 6,
      percentageContentTop: 20,
      menuFontFamily: 'Verdana-Bold',
      TN_pays_blank_position_16_Top: 440,
      TN_pays_blank_position_17_Top: 440,
      TN_pays_blank_position_16_Left: 101,
      TN_pays_blank_position_17_Left: 101,

      splitCard_13_top: 312,
      landscapeSplitCard_13_top: 312,
      landscapeTnimage_split_height: 628,
      tnimage_split_height: 628,
    };
  }

  public static get ro(): translateFontProp {
    return {
      fc21PortraitgameOverTextFontsize: 24,
      fcbfooterBetFontSize: 33,
      fcbhintTextFontSize: 18,
      fcbhintQuestionMarkNumberFontSize: 17,
      fcbspreadhintTextFontSize: 18,
      fcbfooterPaidFontSize: 33,
      fcbfooterCreditFontSize: 33,
      fcbTrendTextFontSize: 30,
      fcbTrendTextNameFontSize: 30,
      fcbTrendTextValueFontSize: 69,
      fcbTrendFooterValueFontSize: 20,
      fcbTrendHeaderFontSize: 27,
      fcbTrendShuffleTextFontSize: 27,
      fcbTrendTotalValueTextFontSize: 40,
      fcbTrendFooterValueKeyFontSize: 20,
      fcbTrendTextFontFamily: 'MyriadPro-BoldCond',
      footerBetFontFamily: 'MyriadPro-Cond',
      keyBoardTextFamily: 'MyriadPro-Cond',
      alertTextFontFamily: 'MyriadPro-Cond',
      footerPaidFontFamily: 'MyriadPro-Cond',
      footerCreditFontFamily: 'MyriadPro-Cond',
      fc21footerBetFontSize: 21,
      fc21footerPaidFontSize: 21,
      fc21footerCreditFontSize: 20,
      fcbaccaratbetLimitMinFontSize: 23,
      fcbaccaratbetLimitMaxFontSize: 23,
      fcbaccaratbetLimitMinFontFamily: 'MyriadPro-Bold',
      fcbaccaratbetLimitMaxFontFamily: 'MyriadPro-Bold',
      fc21betLimitMinFontSize: 17,
      fc21betLimitMinFontSizePortrait: 17,
      fc21betLimitMaxFontSize: 17,
      fc21betLimitMaxFontSizePortrait: 17,
      fc21betLimitMinFontFamily: 'MyriadPro-Bold',
      fc21betLimitMaxFontFamily: 'MyriadPro-Bold',
      fc21paysTextFontFamily: 'MyriadPro-Bold',
      fc21UserNameDesktopFontSize: '.5',
      fc21UserNamemobileFontSize: '.5',
      fcbTrendTotalValueTextFontFamily: 'MyriadPro-BoldCond',
      fc21placeBetsFontSize: 22,
      fc21placeBetsFontFamily: 'MyriadPro-Cond',
      paysContentFontSize: 15,
      percentageContentFontSize: 15,
      paysContentTop: 5,
      percentageContentTop: 20,
      menuFontFamily: 'Verdana-Bold',
      TN_pays_blank_position_16_Top: 452,
      TN_pays_blank_position_17_Top: 452,
      TN_pays_blank_position_16_Left: 94,
      TN_pays_blank_position_17_Left: 94,

      splitCard_13_top: 294,
      landscapeSplitCard_13_top: 294,
      landscapeTnimage_split_height: 572,
      tnimage_split_height: 572,
    };
  }

  public static get si(): translateFontProp {
    return {
      fc21PortraitgameOverTextFontsize: 24,
      fcbfooterBetFontSize: 33,
      fcbhintTextFontSize: 18,
      fcbhintQuestionMarkNumberFontSize: 17,
      fcbspreadhintTextFontSize: 20,
      fcbfooterPaidFontSize: 33,
      fcbfooterCreditFontSize: 33,
      fcbTrendTextFontSize: 29,
      fcbTrendTextNameFontSize: 29,
      fcbTrendTextValueFontSize: 69,
      fcbTrendFooterValueFontSize: 20,
      fcbTrendHeaderFontSize: 30,
      fcbTrendShuffleTextFontSize: 31,
      fcbTrendTotalValueTextFontSize: 40,
      fcbTrendFooterValueKeyFontSize: 20,
      fcbTrendTextFontFamily: 'MyriadPro-BoldCond',
      footerBetFontFamily: 'MyriadPro-Cond',
      keyBoardTextFamily: 'MyriadPro-Cond',
      alertTextFontFamily: 'MyriadPro-Cond',
      footerPaidFontFamily: 'MyriadPro-Cond',
      footerCreditFontFamily: 'MyriadPro-Cond',
      fc21footerBetFontSize: 21,
      fc21footerPaidFontSize: 21,
      fc21footerCreditFontSize: 20,
      fcbaccaratbetLimitMinFontSize: 23,
      fcbaccaratbetLimitMaxFontSize: 20,
      fcbaccaratbetLimitMinFontFamily: 'MyriadPro-Bold',
      fcbaccaratbetLimitMaxFontFamily: 'MyriadPro-Bold',
      fc21betLimitMinFontSize: 17,
      fc21betLimitMinFontSizePortrait: 17,
      fc21betLimitMaxFontSize: 17,
      fc21betLimitMaxFontSizePortrait: 17,
      fc21betLimitMinFontFamily: 'MyriadPro-Bold',
      fc21betLimitMaxFontFamily: 'MyriadPro-Bold',
      fc21paysTextFontFamily: 'MyriadPro-Bold',
      fc21UserNameDesktopFontSize: '.5',
      fc21UserNamemobileFontSize: '.5',
      fcbTrendTotalValueTextFontFamily: 'MyriadPro-BoldCond',
      fc21placeBetsFontSize: 22,
      fc21placeBetsFontFamily: 'MyriadPro-Cond',
      paysContentFontSize: 15,
      percentageContentFontSize: 15,
      paysContentTop: 5,
      percentageContentTop: 20,
      menuFontFamily: 'Verdana-Bold',
      TN_pays_blank_position_16_Top: 469,
      TN_pays_blank_position_17_Top: 469,
      TN_pays_blank_position_16_Left: 90,
      TN_pays_blank_position_17_Left: 90,

      splitCard_13_top: 294,
      landscapeSplitCard_13_top: 294,
      landscapeTnimage_split_height: 572,
      tnimage_split_height: 572,
    };
  }

  public static get sk(): translateFontProp {
    return {
      fc21PortraitgameOverTextFontsize: 24,
      fcbfooterBetFontSize: 33,
      fcbhintTextFontSize: 15,
      fcbhintQuestionMarkNumberFontSize: 16,
      fcbspreadhintTextFontSize: 18,
      fcbfooterPaidFontSize: 33,
      fcbfooterCreditFontSize: 33,
      fcbTrendTextFontSize: 26,
      fcbTrendTextNameFontSize: 24,
      fcbTrendTextValueFontSize: 69,
      fcbTrendFooterValueFontSize: 20,
      fcbTrendHeaderFontSize: 30,
      fcbTrendShuffleTextFontSize: 26,
      fcbTrendTotalValueTextFontSize: 40,
      fcbTrendFooterValueKeyFontSize: 20,
      fcbTrendTextFontFamily: 'MyriadPro-BoldCond',
      footerBetFontFamily: 'MyriadPro-Cond',
      keyBoardTextFamily: 'MyriadPro-Cond',
      alertTextFontFamily: 'MyriadPro-Cond',
      footerPaidFontFamily: 'MyriadPro-Cond',
      footerCreditFontFamily: 'MyriadPro-Cond',
      fc21footerBetFontSize: 21,
      fc21footerPaidFontSize: 21,
      fc21footerCreditFontSize: 20,
      fcbaccaratbetLimitMinFontSize: 23,
      fcbaccaratbetLimitMaxFontSize: 23,
      fcbaccaratbetLimitMinFontFamily: 'MyriadPro-Bold',
      fcbaccaratbetLimitMaxFontFamily: 'MyriadPro-Bold',
      fc21betLimitMinFontSize: 17,
      fc21betLimitMinFontSizePortrait: 17,
      fc21betLimitMaxFontSize: 17,
      fc21betLimitMaxFontSizePortrait: 17,
      fc21betLimitMinFontFamily: 'MyriadPro-Bold',
      fc21betLimitMaxFontFamily: 'MyriadPro-Bold',
      fc21paysTextFontFamily: 'MyriadPro-BoldCond',
      fc21UserNameDesktopFontSize: '.5',
      fc21UserNamemobileFontSize: '.5',
      fcbTrendTotalValueTextFontFamily: 'MyriadPro-BoldCond',
      fc21placeBetsFontSize: 22,
      fc21placeBetsFontFamily: 'MyriadPro-Cond',
      paysContentFontSize: 15,
      percentageContentFontSize: 15,
      paysContentTop: 5,
      percentageContentTop: 20,
      menuFontFamily: 'Verdana-Bold',
      TN_pays_blank_position_16_Top: 475,
      TN_pays_blank_position_17_Top: 475,
      TN_pays_blank_position_16_Left: 84,
      TN_pays_blank_position_17_Left: 84,

      splitCard_13_top: 294,
      landscapeSplitCard_13_top: 294,
      landscapeTnimage_split_height: 572,
      tnimage_split_height: 572,
    };
  }

  public static get 'sr-RS'(): translateFontProp {
    return {
      fc21PortraitgameOverTextFontsize: 24,
      fcbfooterBetFontSize: 33,
      fcbhintTextFontSize: 19,
      fcbhintQuestionMarkNumberFontSize: 20,
      fcbspreadhintTextFontSize: 22,
      fcbfooterPaidFontSize: 33,
      fcbfooterCreditFontSize: 33,
      fcbTrendTextFontSize: 26,
      fcbTrendTextNameFontSize: 26,
      fcbTrendTextValueFontSize: 69,
      fcbTrendFooterValueFontSize: 20,
      fcbTrendHeaderFontSize: 30,
      fcbTrendShuffleTextFontSize: 32,
      fcbTrendTotalValueTextFontSize: 40,
      fcbTrendFooterValueKeyFontSize: 20,
      fcbTrendTextFontFamily: 'MyriadPro-BoldCond',
      footerBetFontFamily: 'MyriadPro-Cond',
      keyBoardTextFamily: 'MyriadPro-Cond',
      alertTextFontFamily: 'MyriadPro-Cond',
      footerPaidFontFamily: 'MyriadPro-Cond',
      footerCreditFontFamily: 'MyriadPro-Cond',
      fc21footerBetFontSize: 21,
      fc21footerPaidFontSize: 21,
      fc21footerCreditFontSize: 20,
      fcbaccaratbetLimitMinFontSize: 23,
      fcbaccaratbetLimitMaxFontSize: 23,
      fcbaccaratbetLimitMinFontFamily: 'MyriadPro-BoldCond',
      fcbaccaratbetLimitMaxFontFamily: 'MyriadPro-BoldCond',
      fc21betLimitMinFontSize: 16,
      fc21betLimitMinFontSizePortrait: 16,
      fc21betLimitMaxFontSize: 16,
      fc21betLimitMaxFontSizePortrait: 16,
      fc21betLimitMinFontFamily: 'MyriadPro-BoldCond',
      fc21betLimitMaxFontFamily: 'MyriadPro-BoldCond',
      fc21paysTextFontFamily: 'MyriadPro-BoldCond',
      fc21UserNameDesktopFontSize: '.5',
      fc21UserNamemobileFontSize: '.5',
      fcbTrendTotalValueTextFontFamily: 'MyriadPro-BoldCond',
      fc21placeBetsFontSize: 22,
      fc21placeBetsFontFamily: 'MyriadPro-Cond',
      paysContentFontSize: 15,
      percentageContentFontSize: 15,
      paysContentTop: 5,
      percentageContentTop: 20,
      menuFontFamily: 'Verdana-Bold',
      TN_pays_blank_position_16_Top: 460,
      TN_pays_blank_position_17_Top: 460,
      TN_pays_blank_position_16_Left: 80,
      TN_pays_blank_position_17_Left: 80,

      splitCard_13_top: 294,
      landscapeSplitCard_13_top: 294,
      landscapeTnimage_split_height: 572,
      tnimage_split_height: 572,
    };
  }

  public static get 'ta-IN'(): translateFontProp {
    return {
      fc21PortraitgameOverTextFontsize: 17,
      fcbfooterBetFontSize: 33,
      fcbhintTextFontSize: 11.5,
      fcbhintQuestionMarkNumberFontSize: 12,
      fcbspreadhintTextFontSize: 16,
      fcbfooterPaidFontSize: 33,
      fcbfooterCreditFontSize: 33,
      fcbTrendTextFontSize: 24,
      fcbTrendTextNameFontSize: 20,
      fcbTrendTextValueFontSize: 69,
      fcbTrendFooterValueFontSize: 17,
      fcbTrendHeaderFontSize: 16,
      fcbTrendShuffleTextFontSize: 13,
      fcbTrendTotalValueTextFontSize: 25,
      fcbTrendFooterValueKeyFontSize: 20,
      fcbTrendTextFontFamily: 'InaiMathi',
      footerBetFontFamily: 'MyriadPro-Cond',
      keyBoardTextFamily: 'MyriadPro-Cond',
      alertTextFontFamily: 'MyriadPro-Cond',
      footerPaidFontFamily: 'MyriadPro-Cond',
      footerCreditFontFamily: 'MyriadPro-Cond',
      fc21footerBetFontSize: 21,
      fc21footerPaidFontSize: 21,
      fc21footerCreditFontSize: 20,
      fcbaccaratbetLimitMinFontSize: 16,
      fcbaccaratbetLimitMaxFontSize: 18,
      fcbaccaratbetLimitMinFontFamily: 'InaiMathi',
      fcbaccaratbetLimitMaxFontFamily: 'InaiMathi',
      fc21betLimitMinFontSize: 10,
      fc21betLimitMinFontSizePortrait: 12,
      fc21betLimitMaxFontSize: 10,
      fc21betLimitMaxFontSizePortrait: 12,
      fc21betLimitMinFontFamily: 'InaiMathi',
      fc21betLimitMaxFontFamily: 'InaiMathi',
      fc21paysTextFontFamily: 'InaiMathi',
      fc21UserNameDesktopFontSize: '.5',
      fc21UserNamemobileFontSize: '.5',
      fcbTrendTotalValueTextFontFamily: 'InaiMathi',
      fc21placeBetsFontSize: 22,
      fc21placeBetsFontFamily: 'MyriadPro-Cond',
      paysContentFontSize: 10,
      percentageContentFontSize: 15,
      paysContentTop: 7,
      percentageContentTop: 22,
      menuFontFamily: 'Verdana-Bold',
      TN_pays_blank_position_16_Top: 453,
      TN_pays_blank_position_17_Top: 453,
      TN_pays_blank_position_16_Left: 74,
      TN_pays_blank_position_17_Left: 74,

      splitCard_13_top: 294,
      landscapeSplitCard_13_top: 294,
      landscapeTnimage_split_height: 572,
      tnimage_split_height: 572,
    };
  }

  public static get ua(): translateFontProp {
    return {
      fc21PortraitgameOverTextFontsize: 22,
      fcbfooterBetFontSize: 33,
      fcbhintTextFontSize: 22,
      fcbhintQuestionMarkNumberFontSize: 22,
      fcbspreadhintTextFontSize: 23,
      fcbfooterPaidFontSize: 33,
      fcbfooterCreditFontSize: 33,
      fcbTrendTextFontSize: 26,
      fcbTrendTextNameFontSize: 26,
      fcbTrendTextValueFontSize: 69,
      fcbTrendFooterValueFontSize: 20,
      fcbTrendHeaderFontSize: 30,
      fcbTrendShuffleTextFontSize: 24,
      fcbTrendTotalValueTextFontSize: 40,
      fcbTrendFooterValueKeyFontSize: 20,
      fcbTrendTextFontFamily: 'MyriadPro-BoldCond',
      footerBetFontFamily: 'MyriadPro-Cond',
      keyBoardTextFamily: 'MyriadPro-Cond',
      alertTextFontFamily: 'MyriadPro-Cond',
      footerPaidFontFamily: 'MyriadPro-Cond',
      footerCreditFontFamily: 'MyriadPro-Cond',
      fc21footerBetFontSize: 21,
      fc21footerPaidFontSize: 21,
      fc21footerCreditFontSize: 20,
      fcbaccaratbetLimitMinFontSize: 23,
      fcbaccaratbetLimitMaxFontSize: 23,
      fcbaccaratbetLimitMinFontFamily: 'MyriadPro-Bold',
      fcbaccaratbetLimitMaxFontFamily: 'MyriadPro-Bold',
      fc21betLimitMinFontSize: 17,
      fc21betLimitMinFontSizePortrait: 17,
      fc21betLimitMaxFontSize: 17,
      fc21betLimitMaxFontSizePortrait: 17,
      fc21betLimitMinFontFamily: 'MyriadPro-Bold',
      fc21betLimitMaxFontFamily: 'MyriadPro-Bold',
      fc21paysTextFontFamily: 'MyriadPro-Bold',
      fc21UserNameDesktopFontSize: '.5',
      fc21UserNamemobileFontSize: '.5',
      fcbTrendTotalValueTextFontFamily: 'MyriadPro-BoldCond',
      fc21placeBetsFontSize: 22,
      fc21placeBetsFontFamily: 'MyriadPro-Cond',
      paysContentFontSize: 15,
      percentageContentFontSize: 15,
      paysContentTop: 5,
      percentageContentTop: 20,
      menuFontFamily: 'Verdana-Bold',
      TN_pays_blank_position_16_Top: 460,
      TN_pays_blank_position_17_Top: 460,
      TN_pays_blank_position_16_Left: 78,
      TN_pays_blank_position_17_Left: 78,

      splitCard_13_top: 294,
      landscapeSplitCard_13_top: 294,
      landscapeTnimage_split_height: 572,
      tnimage_split_height: 572,
    };
  }
}

interface translateFontProp {
  fc21PortraitgameOverTextFontsize: number;
  fcbfooterBetFontSize: number;
  fcbhintTextFontSize: number;
  fcbhintQuestionMarkNumberFontSize: number;
  fcbspreadhintTextFontSize: number;
  fcbfooterPaidFontSize: number;
  fcbfooterCreditFontSize: number;
  fcbTrendTextFontSize: number;
  fcbTrendTextNameFontSize: number;
  fcbTrendTextValueFontSize: number;
  fcbTrendFooterValueFontSize: number;
  fcbTrendHeaderFontSize: number;
  fcbTrendShuffleTextFontSize: number;
  fcbTrendTotalValueTextFontSize: number;
  fcbTrendFooterValueKeyFontSize: number;
  fcbTrendTextFontFamily: string;
  fc21footerBetFontSize: number;
  fc21footerPaidFontSize: number;
  fc21footerCreditFontSize: number;
  footerBetFontFamily: string;
  keyBoardTextFamily: string;
  alertTextFontFamily: string;
  footerPaidFontFamily: string;
  footerCreditFontFamily: string;
  fcbaccaratbetLimitMinFontSize: number;
  fcbaccaratbetLimitMaxFontSize: number;
  fcbaccaratbetLimitMinFontFamily: string;
  fcbaccaratbetLimitMaxFontFamily: string;
  fc21betLimitMinFontSize: number;
  fc21betLimitMinFontSizePortrait: number;
  fc21betLimitMaxFontSize: number;
  fc21betLimitMaxFontSizePortrait: number;
  fc21betLimitMinFontFamily: string;
  fc21betLimitMaxFontFamily: string;
  fc21paysTextFontFamily: string;
  fc21UserNameDesktopFontSize: string;
  fc21UserNamemobileFontSize: string;
  fcbTrendTotalValueTextFontFamily: string;
  fc21placeBetsFontSize: number;
  fc21placeBetsFontFamily: string;
  paysContentFontSize: number;
  percentageContentFontSize: number;
  paysContentTop: number;
  percentageContentTop: number;

  menuFontFamily: string;
  menuLanguageFontFamily?: string;
  TN_pays_blank_position_16_Top: number;
  TN_pays_blank_position_17_Top: number;
  TN_pays_blank_position_16_Left: number;
  TN_pays_blank_position_17_Left: number;

  splitCard_13_top: number;
  landscapeSplitCard_13_top: number;
  landscapeTnimage_split_height: number;
  tnimage_split_height: number;
}
